import * as i0 from '@angular/core';
import { Component, ViewChild, ContentChild, Input, ContentChildren, EventEmitter, Output, Injectable, HostListener, HostBinding, ViewContainerRef, ViewEncapsulation, ViewChildren, Attribute, Directive, Pipe, NgModule, CUSTOM_ELEMENTS_SCHEMA, inject, DestroyRef } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { Subject, BehaviorSubject } from 'rxjs';
import * as i1$1 from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i1$2 from '@doka-shared/date-time';
import { I18NextModule } from 'angular-i18next';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

class AccordionItemComponent {
    constructor() {
        this.activated = false;
    }
    ngAfterContentInit() {
        console.log(this.accordionHeader);
        console.log(this.accordionContent);
        console.log(this.template);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: AccordionItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: AccordionItemComponent, selector: "doka-accordion-item", inputs: { activated: "activated" }, queries: [{ propertyName: "accordionHeader", first: true, predicate: ["header"], descendants: true }, { propertyName: "accordionContent", first: true, predicate: ["content"], descendants: true }], viewQueries: [{ propertyName: "template", first: true, predicate: ["accordionItemTemplate"], descendants: true }], ngImport: i0, template: "<ng-template #accordionItemTemplate class=\"doka-accordion-container\">\n  <div class=\"doka-accordion-item\">\n    <button\n      class=\"doka-accordion\"\n      [ngClass]=\"{ 'doka-accordion-activated': activated }\"\n      (click)=\"activated = !activated\"\n    >\n      <ng-container *ngTemplateOutlet=\"accordionHeader\"></ng-container>\n    </button>\n    <div class=\"doka-accordion-content\">\n      <ng-container *ngTemplateOutlet=\"accordionContent\"></ng-container>\n    </div>\n  </div>\n</ng-template>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: AccordionItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-accordion-item', template: "<ng-template #accordionItemTemplate class=\"doka-accordion-container\">\n  <div class=\"doka-accordion-item\">\n    <button\n      class=\"doka-accordion\"\n      [ngClass]=\"{ 'doka-accordion-activated': activated }\"\n      (click)=\"activated = !activated\"\n    >\n      <ng-container *ngTemplateOutlet=\"accordionHeader\"></ng-container>\n    </button>\n    <div class=\"doka-accordion-content\">\n      <ng-container *ngTemplateOutlet=\"accordionContent\"></ng-container>\n    </div>\n  </div>\n</ng-template>\n" }]
        }], propDecorators: { template: [{
                type: ViewChild,
                args: ['accordionItemTemplate']
            }], accordionHeader: [{
                type: ContentChild,
                args: ['header']
            }], accordionContent: [{
                type: ContentChild,
                args: ['content']
            }], activated: [{
                type: Input
            }] } });

class AccordionComponent {
    ngAfterContentInit() {
        console.log(this.accordionItems);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: AccordionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.11", type: AccordionComponent, selector: "doka-accordion", host: { classAttribute: "doka-accordion-container" }, queries: [{ propertyName: "accordionItems", predicate: AccordionItemComponent }], ngImport: i0, template: "@for (accordion of accordionItems; track $index) {\n<ng-container *ngTemplateOutlet=\"accordion.template\"> </ng-container>\n}\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: AccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-accordion', host: {
                        class: 'doka-accordion-container'
                    }, template: "@for (accordion of accordionItems; track $index) {\n<ng-container *ngTemplateOutlet=\"accordion.template\"> </ng-container>\n}\n" }]
        }], propDecorators: { accordionItems: [{
                type: ContentChildren,
                args: [AccordionItemComponent]
            }] } });

const UIStyle = {
    Information: 'information',
    Success: 'success',
    Warning: 'warning',
    Alert: 'alert',
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { Success, ...reducedType } = UIStyle;
const BannerType = {
    ...reducedType,
};

/**
 * Checks whether a value has changed
 * @param simpleChange is checked for changes
 * @returns
 */
function isChanged(simpleChange) {
    if (simpleChange && simpleChange.currentValue !== simpleChange.previousValue) {
        return true;
    }
    else {
        return false;
    }
}

class BannerComponent {
    constructor() {
        this.actionLabel = null;
        this.message = null;
        this.title = null;
        this.type = BannerType.Information;
        this.clickAction = new EventEmitter();
        this.classBinding = 'doka-banner-information';
        /**
         * The duration for which the banner is displayed, in seconds.
         * If set to null, the banner will not automatically disappear.
         */
        this.duration = null;
        this.onViewDone = new Subject();
        this.onDismiss = new Subject();
    }
    ngOnInit() {
        this.assignValueAccordingToType();
    }
    ngAfterViewInit() {
        this.assignValueAccordingToType();
    }
    ngAfterViewChecked() {
        this.onViewDone.next();
    }
    ngOnDestroy() {
        this.onDismiss.next();
    }
    ngOnChanges(changes) {
        const typeChange = changes['type'];
        if (isChanged(typeChange)) {
            this.type = typeChange.currentValue;
            console.log(typeChange.currentValue);
            this.assignValueAccordingToType();
            console.log(this.classBinding);
        }
    }
    assignValueAccordingToType() {
        if (this.type === BannerType.Information)
            this.classBinding = 'doka-banner-information';
        if (this.type === BannerType.Alert)
            this.classBinding = 'doka-banner-alert';
        if (this.type === BannerType.Warning)
            this.classBinding = 'doka-banner-warning';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: BannerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: BannerComponent, selector: "doka-banner", inputs: { actionLabel: "actionLabel", message: "message", title: "title", type: "type" }, outputs: { clickAction: "clickAction" }, queries: [{ propertyName: "titleT", first: true, predicate: ["bannerTitle"], descendants: true }, { propertyName: "messageT", first: true, predicate: ["message"], descendants: true }, { propertyName: "actionLabelT", first: true, predicate: ["actionLabel"], descendants: true }], viewQueries: [{ propertyName: "dokaBanner", first: true, predicate: ["dokaBanner"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div #dokaBanner class=\"doka-banner\" [ngClass]=\"classBinding\">\n  <div class=\"doka-banner-content\">\n    <span class=\"doka-banner-title\" *ngIf=\"title || titleT\">\n      <ng-container *ngTemplateOutlet=\"titleT\"></ng-container>\n      <p *ngIf=\"title && !titleT\">{{ title }}</p>\n    </span>\n    <span class=\"doka-banner-description\" *ngIf=\"message || messageT\">\n      <ng-container *ngTemplateOutlet=\"messageT\"></ng-container>\n      <p *ngIf=\"message && !messageT\">{{ message }}</p>\n    </span>\n  </div>\n  <div class=\"doka-banner-action\" *ngIf=\"actionLabel || actionLabelT\">\n    <button\n      (click)=\"clickAction.emit($event)\"\n      class=\"doka-banner-action-button\"\n    >\n      <p *ngIf=\"actionLabel && !actionLabelT\">{{ actionLabel }}</p>\n      <ng-container *ngTemplateOutlet=\"actionLabelT\"></ng-container>\n    </button>\n  </div>\n  <!-- TODO: check if update is needed of @uag/doka-design or if we have to manually add border-style: solid to add border to bannerAction -->\n</div>\n", styles: [":host{width:100%}.doka-banner-action-button{border-style:solid}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: BannerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-banner', template: "<div #dokaBanner class=\"doka-banner\" [ngClass]=\"classBinding\">\n  <div class=\"doka-banner-content\">\n    <span class=\"doka-banner-title\" *ngIf=\"title || titleT\">\n      <ng-container *ngTemplateOutlet=\"titleT\"></ng-container>\n      <p *ngIf=\"title && !titleT\">{{ title }}</p>\n    </span>\n    <span class=\"doka-banner-description\" *ngIf=\"message || messageT\">\n      <ng-container *ngTemplateOutlet=\"messageT\"></ng-container>\n      <p *ngIf=\"message && !messageT\">{{ message }}</p>\n    </span>\n  </div>\n  <div class=\"doka-banner-action\" *ngIf=\"actionLabel || actionLabelT\">\n    <button\n      (click)=\"clickAction.emit($event)\"\n      class=\"doka-banner-action-button\"\n    >\n      <p *ngIf=\"actionLabel && !actionLabelT\">{{ actionLabel }}</p>\n      <ng-container *ngTemplateOutlet=\"actionLabelT\"></ng-container>\n    </button>\n  </div>\n  <!-- TODO: check if update is needed of @uag/doka-design or if we have to manually add border-style: solid to add border to bannerAction -->\n</div>\n", styles: [":host{width:100%}.doka-banner-action-button{border-style:solid}\n"] }]
        }], propDecorators: { titleT: [{
                type: ContentChild,
                args: ['bannerTitle', { static: false }]
            }], messageT: [{
                type: ContentChild,
                args: ['message', { static: false }]
            }], actionLabelT: [{
                type: ContentChild,
                args: ['actionLabel', { static: false }]
            }], actionLabel: [{
                type: Input
            }], message: [{
                type: Input
            }], title: [{
                type: Input
            }], type: [{
                type: Input
            }], clickAction: [{
                type: Output
            }], dokaBanner: [{
                type: ViewChild,
                args: ['dokaBanner']
            }] } });

class DokaBannerService {
    constructor() { }
    init(viewContainer) {
        this.viewContainerRef = viewContainer;
    }
    async create(title, message, type, duration) {
        const banner = this.viewContainerRef.createComponent(BannerComponent);
        banner.instance.type = type ?? null;
        banner.instance.title = title;
        banner.instance.message = message ?? null;
        banner.instance.duration = duration;
        banner.instance.onDismiss.subscribe(() => {
            banner.destroy();
        });
        return new Promise((resolve) => {
            const viewDoneSub = banner.instance.onViewDone.subscribe(() => {
                resolve(banner.instance);
                viewDoneSub.unsubscribe();
            });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaBannerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaBannerService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaBannerService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

class BackdropComponent {
    onClick() {
        this.onEmitBackDropClick();
    }
    constructor() {
        this.backDropClicked = new Subject();
    }
    onEmitBackDropClick() {
        console.log('gets clicked');
        this.backDropClicked.next();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: BackdropComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: BackdropComponent, isStandalone: true, selector: "lib-backdrop", host: { listeners: { "click": "onClick($event)" } }, ngImport: i0, template: "\n", styles: [":host{background:#000;position:absolute;inset:0;opacity:.4;z-index:999}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: BackdropComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-backdrop', standalone: true, imports: [], template: "\n", styles: [":host{background:#000;position:absolute;inset:0;opacity:.4;z-index:999}\n"] }]
        }], ctorParameters: () => [], propDecorators: { onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

const ActionIconSize = {
    Small: "sm",
    Normal: "normal",
    Large: "large"
};

const ActionIconType = {
    Default: "default",
    Clear: "clear"
};

class ActionIconComponent {
    constructor(_hostEl) {
        this._hostEl = _hostEl;
        this.activated = false;
        this.icon = null;
        this.isLoading = false;
        this.disabled = false;
        this.size = ActionIconSize.Normal;
        this.type = ActionIconType.Clear;
    }
    ngAfterViewInit() {
        this._hostEl.nativeElement.classList.add('ripple-parent');
    }
    ngOnChanges(changes) {
        if (changes['isLoading'] && !changes['isLoading'].isFirstChange) {
            if (changes['isLoading'].previousValue !== changes['isLoading'].currentValue) {
                this.isLoading = changes['isLoading'].currentValue;
            }
        }
        if (changes['activated'] && !changes['activated'].isFirstChange) {
            if (changes['activated'].previousValue !== changes['activated'].currentValue) {
                this.activated = changes['activated'].currentValue;
            }
        }
        if (changes['icon'] && !changes['icon'].isFirstChange) {
            if (changes['icon'].currentValue !== changes['icon'].previousValue) {
                this.icon = changes['icon'].currentValue;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ActionIconComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.11", type: ActionIconComponent, selector: "doka-action-icon", inputs: { activated: "activated", icon: "icon", isLoading: "isLoading", disabled: "disabled", size: "size", type: "type" }, viewQueries: [{ propertyName: "actionIcon", first: true, predicate: ["actionIcon"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<button\n  #actionIcon\n  class=\"doka-action-icon\"\n  [ngClass]=\"{\n    'doka-action-icon-activated': activated,\n    'disable-back': type === 'clear',\n    'doka-action-icon-large': size === 'large',\n    'doka-action-icon-small': size === 'sm',\n    'doka-bg-none': !activated\n  }\"\n  [disabled]=\"disabled || isLoading\"\n>\n  @if(!isLoading && icon) { {{ icon }} }\n  <ng-content></ng-content>\n  <div class=\"doka-spinner\" *ngIf=\"isLoading\"></div>\n</button>\n", styles: [".background-none{background:none}:host{height:fit-content;width:fit-content}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ActionIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-action-icon', template: "<button\n  #actionIcon\n  class=\"doka-action-icon\"\n  [ngClass]=\"{\n    'doka-action-icon-activated': activated,\n    'disable-back': type === 'clear',\n    'doka-action-icon-large': size === 'large',\n    'doka-action-icon-small': size === 'sm',\n    'doka-bg-none': !activated\n  }\"\n  [disabled]=\"disabled || isLoading\"\n>\n  @if(!isLoading && icon) { {{ icon }} }\n  <ng-content></ng-content>\n  <div class=\"doka-spinner\" *ngIf=\"isLoading\"></div>\n</button>\n", styles: [".background-none{background:none}:host{height:fit-content;width:fit-content}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { activated: [{
                type: Input
            }], icon: [{
                type: Input
            }], isLoading: [{
                type: Input
            }], disabled: [{
                type: Input
            }], size: [{
                type: Input
            }], type: [{
                type: Input
            }], actionIcon: [{
                type: ViewChild,
                args: ['actionIcon']
            }] } });

const IconSize = {
    ExtraSmall: "xs",
    Small: "sm",
    Base: "base",
    Large: "lg",
    ExtraLarge: "xl",
    XXLarge: "2xl",
    XXXLarge: "3xl",
    XXXXLarge: "4xl",
    XXXXXLarge: "5xl"
};

const IconType = {
    Outline: "outline",
    Filled: "filled"
};

class IconComponent {
    constructor() {
        this.name = '';
        this.color = null;
        this.size = IconSize.Large;
        this.type = IconType.Outline;
        this.pxSize = null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: IconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: IconComponent, selector: "doka-icon", inputs: { name: "name", color: "color", size: "size", type: "type", pxSize: "pxSize" }, viewQueries: [{ propertyName: "icon", first: true, predicate: ["icon"], descendants: true }], ngImport: i0, template: "<span\n  [style.font-size]=\"pxSize\"\n  [style.line-height]=\"pxSize ? pxSize : 1\"\n  [ngClass]=\"{\n    filled: type === 'filled',\n    'icon-xs': size === 'xs',\n    'icon-sm': size === 'sm',\n    'icon-base': size === 'base',\n    'icon-lg': size === 'lg',\n    'icon-xl': size === 'xl',\n    'icon-2xl': size === '2xl',\n    'icon-3xl': size === '3xl',\n    'icon-4xl': size === '4xl',\n    'icon-5xl': size === '5xl'\n  }\"\n  #icon\n  class=\"doka-icon\"\n  [style.color]=\"color\"\n>\n  <ng-content></ng-content>\n  {{ name }}\n</span>\n", styles: [":host{display:flex;flex-flow:row;justify-content:center;align-items:center}:host.icon-xs{font-size:12px}:host.icon-sm{font-size:16px}:host.icon-lg{font-size:24px}:host.icon-xl{font-size:32px}.filled{font-variation-settings:\"FILL\" 1,\"opsz\" 24!important}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: IconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-icon', template: "<span\n  [style.font-size]=\"pxSize\"\n  [style.line-height]=\"pxSize ? pxSize : 1\"\n  [ngClass]=\"{\n    filled: type === 'filled',\n    'icon-xs': size === 'xs',\n    'icon-sm': size === 'sm',\n    'icon-base': size === 'base',\n    'icon-lg': size === 'lg',\n    'icon-xl': size === 'xl',\n    'icon-2xl': size === '2xl',\n    'icon-3xl': size === '3xl',\n    'icon-4xl': size === '4xl',\n    'icon-5xl': size === '5xl'\n  }\"\n  #icon\n  class=\"doka-icon\"\n  [style.color]=\"color\"\n>\n  <ng-content></ng-content>\n  {{ name }}\n</span>\n", styles: [":host{display:flex;flex-flow:row;justify-content:center;align-items:center}:host.icon-xs{font-size:12px}:host.icon-sm{font-size:16px}:host.icon-lg{font-size:24px}:host.icon-xl{font-size:32px}.filled{font-variation-settings:\"FILL\" 1,\"opsz\" 24!important}\n"] }]
        }], propDecorators: { name: [{
                type: Input
            }], color: [{
                type: Input
            }], size: [{
                type: Input
            }], type: [{
                type: Input
            }], pxSize: [{
                type: Input
            }], icon: [{
                type: ViewChild,
                args: ['icon']
            }] } });

class ButtonComponent {
    get nonConditionalHostClasses() {
        return {
            'expand': this.expand,
            'expand-h': this.expandH,
        };
    }
    get conditionalHostClasses() {
        return {
            'icon-only': this.iconOnly || (!this.buttonText && !this.textT && !this.buttonTextT && (this.icon || this.iconT)),
            'doka-pointer-events-none': this.isLoading,
            'doka-button-primary': this.color === 'primary',
            'doka-button-secondary': this.color === 'secondary',
            'doka-button-danger': this.color === 'danger',
            'dot-clear': this.color === 'clear',
            'expand': this.expand,
            'expand-h': this.expandH,
            'doka-button-small': this.size === 'small',
            'medium': this.size === 'medium',
            'large': this.size === 'large',
            'doka-button-activated': this.activated,
            'padding-icon-only': (!this.buttonText && !this.buttonTextT && !this.textT) && (this.icon || this.iconT),
        };
    }
    constructor() {
        this.IconSize = IconSize;
        this.content = null;
        this.dokaButton = null;
        this.activated = false;
        this.buttonText = null;
        this.color = 'secondary';
        this.disabled = false;
        this.expand = false;
        this.expandH = false;
        this.isLoading = false;
        this.icon = null;
        this.iconType = IconType.Outline;
        this.iconOnly = false;
        this.size = 'medium';
        this.class = this.isLoading;
    }
    ngOnInit() {
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: ButtonComponent, selector: "doka-button", inputs: { activated: "activated", buttonText: "buttonText", color: "color", disabled: "disabled", expand: "expand", expandH: "expandH", isLoading: "isLoading", icon: "icon", iconType: "iconType", iconOnly: "iconOnly", size: "size", customBackgroundColor: "customBackgroundColor", customColor: "customColor", customBorderColor: "customBorderColor" }, host: { properties: { "class": "this.nonConditionalHostClasses", "class.doka-pointer-events-none": "this.class" } }, queries: [{ propertyName: "buttonTextT", first: true, predicate: ["buttonText"], descendants: true }, { propertyName: "textT", first: true, predicate: ["text"], descendants: true }, { propertyName: "iconT", first: true, predicate: ["icon"], descendants: true }], viewQueries: [{ propertyName: "content", first: true, predicate: ["content"], descendants: true }, { propertyName: "dokaButton", first: true, predicate: ["dokaButton"], descendants: true }], ngImport: i0, template: "<button\n  class=\"doka-button ion-activatable ripple-parent\"\n  [disabled]=\"disabled\"\n  [ngClass]=\"conditionalHostClasses\"\n  [ngStyle]=\"{\n    background: customBackgroundColor,\n    color: customColor,\n    'border-color': customBorderColor\n  }\"\n>\n  <div\n    [style.visibility]=\"isLoading ? 'hidden' : 'visible'\"\n    class=\"content-wrapper\"\n  >\n    <ng-container *ngTemplateOutlet=\"textT ?? buttonTextT\"></ng-container>\n    <p *ngIf=\"buttonText && !textT && !buttonTextT\">{{ buttonText }}</p>\n    <ng-content *ngIf=\"!textT && !iconT && !buttonTextT\"></ng-content>\n    <ng-container *ngTemplateOutlet=\"iconT\"></ng-container>\n    <doka-icon\n      *ngIf=\"icon && !iconT\"\n      [name]=\"icon\"\n      [type]=\"iconType\"\n      [size]=\"iconOnly ? 'xl' : 'lg'\"\n    ></doka-icon>\n  </div>\n  <div *ngIf=\"isLoading\" class=\"doka-spinner content-above\"></div>\n  <ion-ripple-effect class=\"cust-ripple\"></ion-ripple-effect>\n</button>\n", styles: [".cust-ripple{border-radius:6px}:host{border-radius:6px;--background: }.doka-button{display:inline-flex;flex-flow:column nowrap;align-items:center;justify-content:center}.content-above{position:absolute}.content-wrapper{display:inline-flex;flex-flow:row nowrap;flex:1;align-items:center;justify-content:center;gap:var(--spacing-base);position:relative;text-wrap:nowrap}.doka-button-disabled{pointer-events:none;cursor:not-allowed;background:var(--color-background-disabled)!important;border-color:var(--color-border-disabled)!important;color:var(--color-text-disabled)!important}:host-context(.text){display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;height:100%}:host-context(.button){font-size:var(--font-size-body-1);font-weight:900;display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;height:100%}.icon-only{height:44px;width:44px}.small{height:40px!important}.medium-square{height:42px!important;aspect-ratio:1/1}.large{height:64px!important}.dot-clear{background:none;color:var(--color-text-accent)}.dot-clear.icon-only{font-size:24px}.dot-clear:hover{background:none;color:var(--color-text-accent)}.dot-clear:focus{background:none;color:var(--color-text-accent)}ion-icon{font-size:24px}:host.expand{width:100%}.expand{width:100%}:host.expand-h{height:100%}.expand-h{height:100%}.is-hidden{opacity:0}.spinner-primary{--color: #004588}.spinner-secondary{--color: #ffffff}.spinner-tertiary{--color: #004588}.spinner-danger{--color: var(--doka-alert-600, #ec1e2e)}.spinner-clear{--color: #004588}:host{cursor:pointer;-webkit-user-select:none;user-select:none;position:relative;justify-content:center;align-items:center;gap:0px!important;display:flex;height:fit-content;width:fit-content}padding-icon-only{padding:var(--spacing-md)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: i1$1.IonRippleEffect, selector: "ion-ripple-effect", inputs: ["type"] }, { kind: "component", type: IconComponent, selector: "doka-icon", inputs: ["name", "color", "size", "type", "pxSize"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-button', template: "<button\n  class=\"doka-button ion-activatable ripple-parent\"\n  [disabled]=\"disabled\"\n  [ngClass]=\"conditionalHostClasses\"\n  [ngStyle]=\"{\n    background: customBackgroundColor,\n    color: customColor,\n    'border-color': customBorderColor\n  }\"\n>\n  <div\n    [style.visibility]=\"isLoading ? 'hidden' : 'visible'\"\n    class=\"content-wrapper\"\n  >\n    <ng-container *ngTemplateOutlet=\"textT ?? buttonTextT\"></ng-container>\n    <p *ngIf=\"buttonText && !textT && !buttonTextT\">{{ buttonText }}</p>\n    <ng-content *ngIf=\"!textT && !iconT && !buttonTextT\"></ng-content>\n    <ng-container *ngTemplateOutlet=\"iconT\"></ng-container>\n    <doka-icon\n      *ngIf=\"icon && !iconT\"\n      [name]=\"icon\"\n      [type]=\"iconType\"\n      [size]=\"iconOnly ? 'xl' : 'lg'\"\n    ></doka-icon>\n  </div>\n  <div *ngIf=\"isLoading\" class=\"doka-spinner content-above\"></div>\n  <ion-ripple-effect class=\"cust-ripple\"></ion-ripple-effect>\n</button>\n", styles: [".cust-ripple{border-radius:6px}:host{border-radius:6px;--background: }.doka-button{display:inline-flex;flex-flow:column nowrap;align-items:center;justify-content:center}.content-above{position:absolute}.content-wrapper{display:inline-flex;flex-flow:row nowrap;flex:1;align-items:center;justify-content:center;gap:var(--spacing-base);position:relative;text-wrap:nowrap}.doka-button-disabled{pointer-events:none;cursor:not-allowed;background:var(--color-background-disabled)!important;border-color:var(--color-border-disabled)!important;color:var(--color-text-disabled)!important}:host-context(.text){display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;height:100%}:host-context(.button){font-size:var(--font-size-body-1);font-weight:900;display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;height:100%}.icon-only{height:44px;width:44px}.small{height:40px!important}.medium-square{height:42px!important;aspect-ratio:1/1}.large{height:64px!important}.dot-clear{background:none;color:var(--color-text-accent)}.dot-clear.icon-only{font-size:24px}.dot-clear:hover{background:none;color:var(--color-text-accent)}.dot-clear:focus{background:none;color:var(--color-text-accent)}ion-icon{font-size:24px}:host.expand{width:100%}.expand{width:100%}:host.expand-h{height:100%}.expand-h{height:100%}.is-hidden{opacity:0}.spinner-primary{--color: #004588}.spinner-secondary{--color: #ffffff}.spinner-tertiary{--color: #004588}.spinner-danger{--color: var(--doka-alert-600, #ec1e2e)}.spinner-clear{--color: #004588}:host{cursor:pointer;-webkit-user-select:none;user-select:none;position:relative;justify-content:center;align-items:center;gap:0px!important;display:flex;height:fit-content;width:fit-content}padding-icon-only{padding:var(--spacing-md)}\n"] }]
        }], ctorParameters: () => [], propDecorators: { buttonTextT: [{
                type: ContentChild,
                args: ['buttonText', { static: false }]
            }], textT: [{
                type: ContentChild,
                args: ['text', { static: false }]
            }], iconT: [{
                type: ContentChild,
                args: ['icon', { static: false }]
            }], nonConditionalHostClasses: [{
                type: HostBinding,
                args: ['class']
            }], content: [{
                type: ViewChild,
                args: ['content']
            }], dokaButton: [{
                type: ViewChild,
                args: ['dokaButton']
            }], activated: [{
                type: Input
            }], buttonText: [{
                type: Input
            }], color: [{
                type: Input
            }], disabled: [{
                type: Input
            }], expand: [{
                type: Input
            }], expandH: [{
                type: Input
            }], isLoading: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconType: [{
                type: Input
            }], iconOnly: [{
                type: Input
            }], size: [{
                type: Input
            }], customBackgroundColor: [{
                type: Input
            }], customColor: [{
                type: Input
            }], customBorderColor: [{
                type: Input
            }], class: [{
                type: HostBinding,
                args: ['class.doka-pointer-events-none']
            }] } });

class CheckboxComponent {
    constructor() {
        this.alert = null;
        this.expand = false;
        this.checked = false;
        this.checkedChange = new EventEmitter();
        this.desc = null;
        this.disabled = false;
        this.label = null;
        this.inderminate = false;
    }
    get conditionalHostClasses() {
        return {
            'doka-w-full': this.expand,
            'doka-flex': this.expand,
            'doka-flex-1': this.expand
        };
    }
    onChangeChecked(event) {
        this.checked = event.target.checked;
        this.checkedChange.emit(this.checked);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: CheckboxComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: CheckboxComponent, selector: "doka-checkbox", inputs: { alert: "alert", expand: "expand", checked: "checked", desc: "desc", disabled: "disabled", label: "label", inderminate: "inderminate" }, outputs: { checkedChange: "checkedChange" }, host: { properties: { "class": "this.conditionalHostClasses" } }, queries: [{ propertyName: "labelT", first: true, predicate: ["label"], descendants: true }], ngImport: i0, template: "<label\n  [ngClass]=\"{\n    'doka-flex doka-flex-row doka-items-center': labelT,\n    'doka-items-baseline': !labelT,\n  }\"\n  class=\"doka-w-full doka-h-full doka-checkbox-container\"\n  *ngIf=\"alert || desc || label || labelT; else noLabel\"\n>\n  <input\n    type=\"checkbox\"\n    [(checked)]=\"checked\"\n    [disabled]=\"disabled\"\n    (change)=\"onChangeChecked($event)\"\n    class=\"doka-checkbox\"\n    [ngClass]=\"{ 'doka-checkbox-inderminate': inderminate }\"\n  />\n  <span\n    class=\"doka-checkbox-label doka-w-full doka-flex doka-flex-1\"\n    *ngIf=\"label || labelT\"\n  >\n    <ng-container [ngTemplateOutlet]=\"labelT\"> </ng-container>\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n  </span>\n  <span class=\"doka-checkbox-description\" *ngIf=\"desc\">{{ desc }}</span>\n  <span *ngIf=\"alert\" class=\"doka-checkbox-alert-message\">{{ alert }}</span>\n</label>\n\n<ng-template #noLabel>\n  <input\n    type=\"checkbox\"\n    class=\"doka-checkbox\"\n    [disabled]=\"disabled\"\n    (change)=\"onChangeChecked($event)\"\n    [checked]=\"checked\"\n  />\n</ng-template>\n", styles: [".doka-checkbox:before{top:auto}.doka-checkbox-label{max-width:unset}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: CheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-checkbox', template: "<label\n  [ngClass]=\"{\n    'doka-flex doka-flex-row doka-items-center': labelT,\n    'doka-items-baseline': !labelT,\n  }\"\n  class=\"doka-w-full doka-h-full doka-checkbox-container\"\n  *ngIf=\"alert || desc || label || labelT; else noLabel\"\n>\n  <input\n    type=\"checkbox\"\n    [(checked)]=\"checked\"\n    [disabled]=\"disabled\"\n    (change)=\"onChangeChecked($event)\"\n    class=\"doka-checkbox\"\n    [ngClass]=\"{ 'doka-checkbox-inderminate': inderminate }\"\n  />\n  <span\n    class=\"doka-checkbox-label doka-w-full doka-flex doka-flex-1\"\n    *ngIf=\"label || labelT\"\n  >\n    <ng-container [ngTemplateOutlet]=\"labelT\"> </ng-container>\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n  </span>\n  <span class=\"doka-checkbox-description\" *ngIf=\"desc\">{{ desc }}</span>\n  <span *ngIf=\"alert\" class=\"doka-checkbox-alert-message\">{{ alert }}</span>\n</label>\n\n<ng-template #noLabel>\n  <input\n    type=\"checkbox\"\n    class=\"doka-checkbox\"\n    [disabled]=\"disabled\"\n    (change)=\"onChangeChecked($event)\"\n    [checked]=\"checked\"\n  />\n</ng-template>\n", styles: [".doka-checkbox:before{top:auto}.doka-checkbox-label{max-width:unset}\n"] }]
        }], propDecorators: { conditionalHostClasses: [{
                type: HostBinding,
                args: ['class']
            }], alert: [{
                type: Input
            }], expand: [{
                type: Input
            }], checked: [{
                type: Input
            }], checkedChange: [{
                type: Output
            }], desc: [{
                type: Input
            }], disabled: [{
                type: Input
            }], label: [{
                type: Input
            }], inderminate: [{
                type: Input
            }], labelT: [{
                type: ContentChild,
                args: ['label', { static: false }]
            }] } });

class SearchFieldComponent {
    constructor() {
        this.disabled = false;
        this.placeholder = 'Search';
        this.value = null;
        this.valueChange = new EventEmitter();
        this.onSearch = new EventEmitter();
        this.onSelectHighlight = new EventEmitter();
        this.showResultHighlights = true;
    }
    onInputSearchValue(event) {
        this.value = event.target.value;
        this.showResultHighlights = true;
        this.valueChange.emit(this.value);
        if (this.availableSearchResults &&
            this.availableSearchResults.length > 0 &&
            this.value !== '') {
            this.resultHighlights = this.availableSearchResults.filter((sr) => sr.toLowerCase().includes(this.value.toLowerCase()));
        }
        if (this.value === '' || !this.value) {
            this.resultHighlights = [];
        }
    }
    onFocusInput() {
        this.showResultHighlights = true;
    }
    onBlurInput() {
        this.showResultHighlights = false;
    }
    onPressClear() {
        this.value = '';
        this.resultHighlights = [];
        this.valueChange.emit(this.value);
    }
    onSelectItem(item) {
        this.onSelectHighlight.emit(item);
        this.value = item;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SearchFieldComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: SearchFieldComponent, selector: "doka-search-field", inputs: { resultHighlights: "resultHighlights", availableSearchResults: "availableSearchResults", disabled: "disabled", placeholder: "placeholder", value: "value" }, outputs: { valueChange: "valueChange", onSearch: "onSearch", onSelectHighlight: "onSelectHighlight" }, host: { classAttribute: "doka-search-field-container" }, ngImport: i0, template: "<div class=\"doka-search-field-input\">\n  <input\n    [ngClass]=\"{ 'border-right': !value || value.length < 1 }\"\n    class=\"doka-search-field\"\n    [value]=\"value\"\n    (focus)=\"onFocusInput()\"\n    (blur)=\"onBlurInput()\"\n    [disabled]=\"disabled\"\n    (input)=\"onInputSearchValue($event)\"\n    placeholder=\"{{ placeholder }}\"\n    type=\"search\"\n    (search)=\"onSearch.emit($event)\"\n  />\n  <button\n    [ngClass]=\"{ 'doka-hidden': !value || value.length < 1 }\"\n    class=\"doka-search-field-clearButton\"\n    (click)=\"onPressClear()\"\n    tabindex=\"-1\"\n  ></button>\n</div>\n<div\n  class=\"doka-search-field-results-container\"\n  *ngIf=\"\n    resultHighlights && resultHighlights.length > 0 && showResultHighlights\n  \"\n>\n  <ul class=\"doka-search-field-results\">\n    <li\n      *ngFor=\"let item of resultHighlights\"\n      (mousedown)=\"onSelectItem(item)\"\n      class=\"doka-search-field-result-item\"\n    >\n      <span class=\"doka-search-field-result-item-highlight\">\n        {{ item }}\n      </span>\n    </li>\n  </ul>\n</div>\n", styles: [".doka-search-field-results-container{background:#fff}.doka-search-field.border-right{border-right-width:1px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SearchFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-search-field', host: { class: 'doka-search-field-container' }, template: "<div class=\"doka-search-field-input\">\n  <input\n    [ngClass]=\"{ 'border-right': !value || value.length < 1 }\"\n    class=\"doka-search-field\"\n    [value]=\"value\"\n    (focus)=\"onFocusInput()\"\n    (blur)=\"onBlurInput()\"\n    [disabled]=\"disabled\"\n    (input)=\"onInputSearchValue($event)\"\n    placeholder=\"{{ placeholder }}\"\n    type=\"search\"\n    (search)=\"onSearch.emit($event)\"\n  />\n  <button\n    [ngClass]=\"{ 'doka-hidden': !value || value.length < 1 }\"\n    class=\"doka-search-field-clearButton\"\n    (click)=\"onPressClear()\"\n    tabindex=\"-1\"\n  ></button>\n</div>\n<div\n  class=\"doka-search-field-results-container\"\n  *ngIf=\"\n    resultHighlights && resultHighlights.length > 0 && showResultHighlights\n  \"\n>\n  <ul class=\"doka-search-field-results\">\n    <li\n      *ngFor=\"let item of resultHighlights\"\n      (mousedown)=\"onSelectItem(item)\"\n      class=\"doka-search-field-result-item\"\n    >\n      <span class=\"doka-search-field-result-item-highlight\">\n        {{ item }}\n      </span>\n    </li>\n  </ul>\n</div>\n", styles: [".doka-search-field-results-container{background:#fff}.doka-search-field.border-right{border-right-width:1px}\n"] }]
        }], ctorParameters: () => [], propDecorators: { resultHighlights: [{
                type: Input
            }], availableSearchResults: [{
                type: Input
            }], disabled: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], onSearch: [{
                type: Output
            }], onSelectHighlight: [{
                type: Output
            }] } });

class SelectModalComponent {
    constructor(_platform, _hostEl) {
        this._platform = _platform;
        this._hostEl = _hostEl;
        this.options = [];
        this.label = null;
        this.placeholderSearchBar = null;
        this.cancelButtonText = 'Cancel';
        this.confirmButtonText = 'Select';
        this.showSearchBar = false;
        this.isMulti = false;
        this.selectSearchValue = null;
        this._onDismiss = new Subject();
        this.viewSub = new Subject();
        this._platform.backButton.subscribe(() => {
            this.onDismiss(true);
        });
    }
    ngOnInit() { }
    ngAfterViewInit() {
        this._hostEl.nativeElement.style.height =
            this._hostEl.nativeElement.offsetHeight + 'px';
        this._hostEl.nativeElement.style.width =
            this._hostEl.nativeElement.offsetWidth + 'px';
    }
    ngAfterViewChecked() {
        this.viewSub.next();
    }
    onDidDismiss() {
        return new Promise((resolve) => {
            const didDismissSub = this._onDismiss.subscribe((selectedEntries) => {
                resolve(selectedEntries);
                didDismissSub.unsubscribe();
            });
        });
    }
    onSelectOption(option) {
        if (this.isMulti) {
            option.checked = !option.checked;
        }
        else {
            this.options
                .filter((opt) => opt.value !== option.value)
                .forEach((tempOption) => {
                tempOption.checked = false;
            });
            option.checked = !option.checked;
        }
        console.log(option.checked);
    }
    onDismiss(cancel = false) {
        if (cancel) {
            this._onDismiss.next(null);
        }
        else {
            const selectedOptions = this.options.filter((option) => option.checked);
            console.log(selectedOptions);
            this._onDismiss.next(selectedOptions);
        }
    }
    getSearchedOptions() {
        const searchValue = this.selectSearchValue.toLowerCase();
        return this.options.filter((option) => {
            if (option.label.toLowerCase().includes(searchValue)) {
                return true;
            }
            if (option.searchValue) {
                if (option.searchValue.toLowerCase().includes(searchValue)) {
                    return true;
                }
            }
        });
    }
    onCheckedChange(value, option) {
        if (!this.isMulti && value) {
            this.options.forEach((opt) => {
                if (opt.value !== option.value) {
                    opt.checked = false;
                }
            });
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SelectModalComponent, deps: [{ token: i1$1.Platform }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: SelectModalComponent, selector: "lib-select-modal", inputs: { options: "options", label: "label", placeholderSearchBar: "placeholderSearchBar", cancelButtonText: "cancelButtonText", confirmButtonText: "confirmButtonText", showSearchBar: "showSearchBar", isMulti: "isMulti" }, viewQueries: [{ propertyName: "container", first: true, predicate: ["dynamicContainer"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: "<div class=\"content\">\n  <doka-action-icon\n    (click)=\"onDismiss(true)\"\n    icon=\"close\"\n    style=\"\n      position: absolute;\n      top: var(--spacing-base);\n      right: var(--spacing-base);\n      z-index: 1;\n    \"\n  ></doka-action-icon>\n  <div class=\"flex-column width-100\" style=\"position: sticky; top: 0\">\n    <div class=\"select-modal-header\">\n      <h5>{{ label ?? \"\" }}</h5>\n    </div>\n    <doka-search-field\n      style=\"width: 100%\"\n      *ngIf=\"showSearchBar\"\n      [placeholder]=\"placeholderSearchBar\"\n      [(value)]=\"selectSearchValue\"\n    ></doka-search-field>\n  </div>\n  <div class=\"entry-container\">\n    <div\n      *ngFor=\"\n        let option of selectSearchValue ? getSearchedOptions() : options;\n        let index = index\n      \"\n      [ngClass]=\"{ shaded: index % 2 === 0 }\"\n      class=\"entry\"\n    >\n      <doka-checkbox\n        [(checked)]=\"option.checked\"\n        [expand]=\"true\"\n        (checkedChange)=\"onCheckedChange($event, option)\"\n        class=\"doka-select-none doka-w-full\"\n      >\n        <ng-template #label>\n          <ng-container *ngIf=\"option.content; else noContent\">\n            <ng-container [ngTemplateOutlet]=\"option.content\"></ng-container>\n          </ng-container>\n        </ng-template>\n      </doka-checkbox>\n      <ng-template #noContent>\n        <p>\n          {{ option.label }}\n        </p>\n      </ng-template>\n    </div>\n  </div>\n  <div class=\"action-row\" style=\"position: sticky; bottom: 0\">\n    <doka-button (click)=\"onDismiss(true)\">\n      {{ cancelButtonText }}\n    </doka-button>\n    <doka-button color=\"primary\" (click)=\"onDismiss()\">\n      {{ confirmButtonText }}\n    </doka-button>\n  </div>\n</div>\n", styles: [":host{position:absolute;display:flex;flex-flow:column;width:100%;justify-content:center;background:#fff;border-radius:5px;height:fit-content;width:fit-content;-webkit-user-select:none;user-select:none;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1000}@media only screen and (orientation: landscape){:host{max-width:50vw;max-height:70vh}}@media only screen and (orientation: portrait){:host{max-width:calc(100vw - var(--spacing-base));max-height:calc(100vh - var(--spacing-base))}}.action-row{display:flex;flex-flow:row;justify-content:space-between;gap:var(--spacing-base)}.backdrop{background:#000;opacity:.5;z-index:999;position:absolute;inset:0}.content{display:flex;flex-flow:column;padding:var(--spacing-base);gap:var(--spacing-base);height:100%;overflow-y:auto;min-width:350px}.doka-checkbox{margin-right:0}.entry{display:flex;flex-flow:row nowrap;width:100%;align-items:center;padding:var(--spacing-base);gap:var(--spacing-lg);cursor:pointer}.entry-container{display:flex;flex-flow:column nowrap;align-items:center;flex:1;overflow:auto}.shaded{background:var(--color-background-gray-ultra-ultra-light)}.select-modal-header{height:48px;display:flex;flex-flow:row;align-items:center;justify-content:flex-start}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: ActionIconComponent, selector: "doka-action-icon", inputs: ["activated", "icon", "isLoading", "disabled", "size", "type"] }, { kind: "component", type: ButtonComponent, selector: "doka-button", inputs: ["activated", "buttonText", "color", "disabled", "expand", "expandH", "isLoading", "icon", "iconType", "iconOnly", "size", "customBackgroundColor", "customColor", "customBorderColor"] }, { kind: "component", type: CheckboxComponent, selector: "doka-checkbox", inputs: ["alert", "expand", "checked", "desc", "disabled", "label", "inderminate"], outputs: ["checkedChange"] }, { kind: "component", type: SearchFieldComponent, selector: "doka-search-field", inputs: ["resultHighlights", "availableSearchResults", "disabled", "placeholder", "value"], outputs: ["valueChange", "onSearch", "onSelectHighlight"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SelectModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-select-modal', template: "<div class=\"content\">\n  <doka-action-icon\n    (click)=\"onDismiss(true)\"\n    icon=\"close\"\n    style=\"\n      position: absolute;\n      top: var(--spacing-base);\n      right: var(--spacing-base);\n      z-index: 1;\n    \"\n  ></doka-action-icon>\n  <div class=\"flex-column width-100\" style=\"position: sticky; top: 0\">\n    <div class=\"select-modal-header\">\n      <h5>{{ label ?? \"\" }}</h5>\n    </div>\n    <doka-search-field\n      style=\"width: 100%\"\n      *ngIf=\"showSearchBar\"\n      [placeholder]=\"placeholderSearchBar\"\n      [(value)]=\"selectSearchValue\"\n    ></doka-search-field>\n  </div>\n  <div class=\"entry-container\">\n    <div\n      *ngFor=\"\n        let option of selectSearchValue ? getSearchedOptions() : options;\n        let index = index\n      \"\n      [ngClass]=\"{ shaded: index % 2 === 0 }\"\n      class=\"entry\"\n    >\n      <doka-checkbox\n        [(checked)]=\"option.checked\"\n        [expand]=\"true\"\n        (checkedChange)=\"onCheckedChange($event, option)\"\n        class=\"doka-select-none doka-w-full\"\n      >\n        <ng-template #label>\n          <ng-container *ngIf=\"option.content; else noContent\">\n            <ng-container [ngTemplateOutlet]=\"option.content\"></ng-container>\n          </ng-container>\n        </ng-template>\n      </doka-checkbox>\n      <ng-template #noContent>\n        <p>\n          {{ option.label }}\n        </p>\n      </ng-template>\n    </div>\n  </div>\n  <div class=\"action-row\" style=\"position: sticky; bottom: 0\">\n    <doka-button (click)=\"onDismiss(true)\">\n      {{ cancelButtonText }}\n    </doka-button>\n    <doka-button color=\"primary\" (click)=\"onDismiss()\">\n      {{ confirmButtonText }}\n    </doka-button>\n  </div>\n</div>\n", styles: [":host{position:absolute;display:flex;flex-flow:column;width:100%;justify-content:center;background:#fff;border-radius:5px;height:fit-content;width:fit-content;-webkit-user-select:none;user-select:none;top:50%;left:50%;transform:translate(-50%,-50%);z-index:1000}@media only screen and (orientation: landscape){:host{max-width:50vw;max-height:70vh}}@media only screen and (orientation: portrait){:host{max-width:calc(100vw - var(--spacing-base));max-height:calc(100vh - var(--spacing-base))}}.action-row{display:flex;flex-flow:row;justify-content:space-between;gap:var(--spacing-base)}.backdrop{background:#000;opacity:.5;z-index:999;position:absolute;inset:0}.content{display:flex;flex-flow:column;padding:var(--spacing-base);gap:var(--spacing-base);height:100%;overflow-y:auto;min-width:350px}.doka-checkbox{margin-right:0}.entry{display:flex;flex-flow:row nowrap;width:100%;align-items:center;padding:var(--spacing-base);gap:var(--spacing-lg);cursor:pointer}.entry-container{display:flex;flex-flow:column nowrap;align-items:center;flex:1;overflow:auto}.shaded{background:var(--color-background-gray-ultra-ultra-light)}.select-modal-header{height:48px;display:flex;flex-flow:row;align-items:center;justify-content:flex-start}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.Platform }, { type: i0.ElementRef }], propDecorators: { options: [{
                type: Input
            }], label: [{
                type: Input
            }], placeholderSearchBar: [{
                type: Input
            }], cancelButtonText: [{
                type: Input
            }], confirmButtonText: [{
                type: Input
            }], showSearchBar: [{
                type: Input
            }], isMulti: [{
                type: Input
            }], container: [{
                type: ViewChild,
                args: ['dynamicContainer', { read: ViewContainerRef, static: true }]
            }] } });

/**
 *
 * @param inputArray : any[]
 * @returns a deep Copy of the inputArray
 */
function deepCopy(inputArray) {
    const copy = [];
    inputArray.forEach((item) => {
        if (Array.isArray(item)) {
            copy.push(this.deepCopy(item));
        }
        else {
            copy.push(item);
        }
    });
    return copy;
}

class DokaSelectService {
    constructor() { }
    init(viewContainer) {
        this.viewContainerRef = viewContainer;
        this.os = this.getMobileOperatingSystem();
    }
    async create(options, isMulti = false, showSearchBar = false, label, placeholderSearchBar, cancelButtonText, confirmButtonText) {
        const backdrop = this.viewContainerRef.createComponent(BackdropComponent);
        const selectModal = this.viewContainerRef.createComponent(SelectModalComponent);
        const backDropSub = backdrop.instance.backDropClicked.subscribe(() => {
            backdrop.destroy();
            selectModal.destroy();
            backDropSub.unsubscribe();
            onDismissSub.unsubscribe();
        });
        selectModal.instance.options = deepCopy(options);
        selectModal.instance.isMulti = isMulti;
        selectModal.instance.showSearchBar = showSearchBar;
        if (label)
            selectModal.instance.label = label;
        if (placeholderSearchBar)
            selectModal.instance.placeholderSearchBar = placeholderSearchBar;
        if (cancelButtonText)
            selectModal.instance.cancelButtonText = cancelButtonText;
        if (confirmButtonText)
            selectModal.instance.confirmButtonText = confirmButtonText;
        const onDismissSub = selectModal.instance._onDismiss.subscribe(() => {
            backdrop.destroy();
            selectModal.destroy();
            backDropSub.unsubscribe();
            onDismissSub.unsubscribe();
        });
        return new Promise((resolve) => {
            const viewDoneSub = selectModal.instance.viewSub.subscribe(() => {
                resolve(selectModal.instance);
                viewDoneSub.unsubscribe();
            });
        });
    }
    /**
     * Determine the mobile operating system.
     * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
     *
     * @returns {String}
     */
    getMobileOperatingSystem() {
        const userAgent = navigator.userAgent;
        // Windows Phone must come first because its UA also contains "Android"
        if (/windows phone/i.test(userAgent)) {
            return 'Windows Phone';
        }
        if (/android/i.test(userAgent)) {
            return 'Android';
        }
        // iOS detection from: http://stackoverflow.com/a/9039885/177710
        if (/iPad|iPhone|iPod/.test(userAgent)) {
            return 'iOS';
        }
        return 'Web';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaSelectService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaSelectService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaSelectService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

const ToastType = UIStyle;
var ToastPosition;
(function (ToastPosition) {
    ToastPosition["TopRight"] = "justify-end";
    ToastPosition["BottomCenter"] = "justify-center";
})(ToastPosition || (ToastPosition = {}));

class ErrorToastDetailsComponent {
    constructor(_modalController) {
        this._modalController = _modalController;
        this.message = null;
        this.bodyKeys = null;
    }
    ngOnInit() {
        console.log(this.errorDetails);
        this.message = this.errorDetails.error.detail;
        if (this.errorDetails.requestBody) {
            this.bodyKeys = Object.keys(this.errorDetails.requestBody);
        }
        console.log(this.bodyKeys);
        if (!this.message) {
            this.message = this.errorDetails.error.exceptionDetails
                ? this.errorDetails.error.exceptionDetails[0].message
                : null;
        }
    }
    dismiss() {
        this._modalController.dismiss(null, null, 'errorModal');
    }
    log() {
        console.log(this.errorDetails);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ErrorToastDetailsComponent, deps: [{ token: i1$1.ModalController }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.11", type: ErrorToastDetailsComponent, selector: "lib-toast-details", inputs: { errorDetails: "errorDetails" }, ngImport: i0, template: "<div class=\"inner-content\">\n  <div class=\"doka-toast-details\">\n    <div class=\"doka-toast-details-header\">\n      <div class=\"doka-toast-details-error-identifier\">\n        <p style=\"font-size: 1.5rem\">\n          <b>{{ errorTranslations.errorCode }}: </b>\n          {{ errorDetails.status }}\n        </p>\n      </div>\n      <div class=\"doka-toast-details-func-name\" *ngIf=\"errorDetails.funcName\">\n        <p>\n          <b>{{ errorTranslations.funcName }}: </b>\n          {{ errorDetails.funcName }}\n        </p>\n      </div>\n      <div class=\"error-details-url\" *ngIf=\"errorDetails.url\">\n        <p>\n          <b>{{ errorTranslations.errorUrl }}: </b>\n          {{ errorDetails.url }}\n        </p>\n      </div>\n      <div class=\"doka-toast-details-name\" *ngIf=\"errorDetails.name\">\n        <p>\n          <b>{{ errorTranslations.errorName }}: </b>\n          {{ errorDetails.error.title ?? \"\" }}\n        </p>\n      </div>\n    </div>\n    <div class=\"doka-toast-details-message\">\n      <h5>{{ errorTranslations.errorDetails }}</h5>\n      @if(this.message) {\n      <p>{{ this.message }}</p>\n      } @else {\n      <p>Undefined</p>\n      }\n      <div class=\"flex-column gap width100\" *ngIf=\"bodyKeys\">\n        <h5>{{ errorTranslations.errorBody }}</h5>\n        <p>{{ \"{\" }}</p>\n        <p class=\"padding-left\" *ngFor=\"let key of bodyKeys\">\n          {{ key }}:\n          {{\n            errorDetails.requestBody[key]\n              ? errorDetails.requestBody[key]?.toString()\n              : \"undefined\"\n          }}\n        </p>\n        <p>{{ \"}\" }}</p>\n      </div>\n    </div>\n    <div class=\"doka-toast-details-buttons\">\n      <doka-button (click)=\"dismiss()\" color=\"secondary\">\n        <ng-template #buttonText>\n          {{ errorTranslations.confirmButton }}\n        </ng-template>\n      </doka-button>\n    </div>\n  </div>\n  <doka-button\n    style=\"position: absolute; top: 16px; right: 16px\"\n    icon=\"close\"\n    color=\"clear\"\n    [iconOnly]=\"true\"\n    (click)=\"dismiss()\"\n  >\n  </doka-button>\n</div>\n", styles: [".doka-toast-details{display:flex;flex-flow:column nowrap;height:100%;width:100%;overflow:auto;inset:0}.doka-toast-details-header{display:flex;flex-shrink:0;flex-flow:column nowrap;justify-content:center;gap:8px;padding:16px;background:var(--color-background-alert-light)}.doka-toast-details-message{display:flex;flex-flow:column;flex-grow:1;padding:16px;text-wrap:wrap;overflow-y:auto;gap:var(--spacing-base)}.doka-toast-details-buttons{display:flex;flex-shrink:0;flex-flow:row;justify-content:flex-end;padding:16px}p{text-wrap:wrap;-moz-user-select:text;-khtml-user-select:text;-webkit-user-select:text;-ms-user-select:text;user-select:text}ion-content{--background: white}@media only screen and (min-width: 768px) and (min-height: 600px){{border-radius:5px}}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ButtonComponent, selector: "doka-button", inputs: ["activated", "buttonText", "color", "disabled", "expand", "expandH", "isLoading", "icon", "iconType", "iconOnly", "size", "customBackgroundColor", "customColor", "customBorderColor"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ErrorToastDetailsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-toast-details', template: "<div class=\"inner-content\">\n  <div class=\"doka-toast-details\">\n    <div class=\"doka-toast-details-header\">\n      <div class=\"doka-toast-details-error-identifier\">\n        <p style=\"font-size: 1.5rem\">\n          <b>{{ errorTranslations.errorCode }}: </b>\n          {{ errorDetails.status }}\n        </p>\n      </div>\n      <div class=\"doka-toast-details-func-name\" *ngIf=\"errorDetails.funcName\">\n        <p>\n          <b>{{ errorTranslations.funcName }}: </b>\n          {{ errorDetails.funcName }}\n        </p>\n      </div>\n      <div class=\"error-details-url\" *ngIf=\"errorDetails.url\">\n        <p>\n          <b>{{ errorTranslations.errorUrl }}: </b>\n          {{ errorDetails.url }}\n        </p>\n      </div>\n      <div class=\"doka-toast-details-name\" *ngIf=\"errorDetails.name\">\n        <p>\n          <b>{{ errorTranslations.errorName }}: </b>\n          {{ errorDetails.error.title ?? \"\" }}\n        </p>\n      </div>\n    </div>\n    <div class=\"doka-toast-details-message\">\n      <h5>{{ errorTranslations.errorDetails }}</h5>\n      @if(this.message) {\n      <p>{{ this.message }}</p>\n      } @else {\n      <p>Undefined</p>\n      }\n      <div class=\"flex-column gap width100\" *ngIf=\"bodyKeys\">\n        <h5>{{ errorTranslations.errorBody }}</h5>\n        <p>{{ \"{\" }}</p>\n        <p class=\"padding-left\" *ngFor=\"let key of bodyKeys\">\n          {{ key }}:\n          {{\n            errorDetails.requestBody[key]\n              ? errorDetails.requestBody[key]?.toString()\n              : \"undefined\"\n          }}\n        </p>\n        <p>{{ \"}\" }}</p>\n      </div>\n    </div>\n    <div class=\"doka-toast-details-buttons\">\n      <doka-button (click)=\"dismiss()\" color=\"secondary\">\n        <ng-template #buttonText>\n          {{ errorTranslations.confirmButton }}\n        </ng-template>\n      </doka-button>\n    </div>\n  </div>\n  <doka-button\n    style=\"position: absolute; top: 16px; right: 16px\"\n    icon=\"close\"\n    color=\"clear\"\n    [iconOnly]=\"true\"\n    (click)=\"dismiss()\"\n  >\n  </doka-button>\n</div>\n", styles: [".doka-toast-details{display:flex;flex-flow:column nowrap;height:100%;width:100%;overflow:auto;inset:0}.doka-toast-details-header{display:flex;flex-shrink:0;flex-flow:column nowrap;justify-content:center;gap:8px;padding:16px;background:var(--color-background-alert-light)}.doka-toast-details-message{display:flex;flex-flow:column;flex-grow:1;padding:16px;text-wrap:wrap;overflow-y:auto;gap:var(--spacing-base)}.doka-toast-details-buttons{display:flex;flex-shrink:0;flex-flow:row;justify-content:flex-end;padding:16px}p{text-wrap:wrap;-moz-user-select:text;-khtml-user-select:text;-webkit-user-select:text;-ms-user-select:text;user-select:text}ion-content{--background: white}@media only screen and (min-width: 768px) and (min-height: 600px){{border-radius:5px}}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.ModalController }], propDecorators: { errorDetails: [{
                type: Input
            }] } });

class ToastErrorTranslations {
    constructor() {
        this.errorCode = 'Error Code';
        this.funcName = 'Function Name';
        this.errorUrl = 'URL';
        this.errorName = 'Error Name';
        this.errorDetails = 'Details';
        this.errorBody = 'Body';
        this.confirmButton = 'Ok';
    }
}

const POSITIONING_DEFAULT = {
    closed: { top: '80px', bottom: 'unset', right: '-100%' },
    open: { top: '80px', bottom: 'unset', right: '16px' },
};
const POSITIONING_BOTTOM_CENTER = {
    closed: { top: 'unset', bottom: '-156px', right: 'unset' },
    open: { top: 'unset', bottom: '56px', right: 'unset' },
};
class ToastComponent {
    get openClose() {
        const positioning = this.getPositioning();
        return {
            value: this.isOpen,
            params: {
                closedBottom: positioning.closed.bottom,
                openedBottom: positioning.open.bottom,
                closedTop: positioning.closed.top,
                openedTop: positioning.open.top,
                closedRight: positioning.closed.right,
                openedRight: positioning.open.right,
            },
        };
    }
    openCloseDone(event) {
        if (this.duration) {
            this.dismissState = 'dismissed';
        }
        if (event.fromState === 'open' && event.toState === 'closed') {
            console.log('dismissed', event);
            this.onDismiss.next();
        }
    }
    get conditionaClasses() {
        return {
            'bottom-centered': this.position === ToastPosition.BottomCenter,
        };
    }
    ngAfterViewInit() {
        this._viewInitComplete = true;
    }
    ngAfterViewChecked() {
        this.viewSub.next();
    }
    constructor(_modalController) {
        this._modalController = _modalController;
        this.type = ToastType.Information;
        this.duration = 5;
        this.showDetailsText = 'Show Details';
        this.errorTranslations = new ToastErrorTranslations();
        this.showIndicator = false;
        this.position = ToastPosition.TopRight;
        this.viewSub = new Subject();
        this.onDismiss = new Subject();
        this.isOpen = 'closed';
        this.dismissState = 'opened';
        this.message = null;
        this.positionEnum = ToastPosition;
        this.toastTypeEnum = ToastType;
        this._viewInitComplete = false;
    }
    hide() {
        this.isOpen = 'closed';
    }
    onDidDismiss() {
        return new Promise((resolve) => {
            const didDismissSub = this.onDismiss.subscribe(() => {
                resolve();
                didDismissSub.unsubscribe();
            });
        });
    }
    show() {
        this.isOpen = this.isOpen === 'closed' ? 'open' : 'closed';
        this.dismissState = 'opened';
    }
    dismissDone(event) {
        if (event.toState === 'dismissed') {
            this.isOpen = 'closed';
        }
    }
    async openErrorDetails() {
        const modal = await this._modalController.create({
            component: ErrorToastDetailsComponent,
            id: 'errorModal',
            componentProps: {
                errorDetails: { ...this.toastDetails.error },
                errorTranslations: this.errorTranslations,
            },
            cssClass: 'errorModal',
        });
        await modal.present();
        this.isOpen = 'closed';
    }
    getPositioning() {
        switch (this.position) {
            case ToastPosition.BottomCenter:
                return POSITIONING_BOTTOM_CENTER;
            default:
                return POSITIONING_DEFAULT;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ToastComponent, deps: [{ token: i1$1.ModalController }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.11", type: ToastComponent, selector: "doka-toast", inputs: { type: "type", duration: "duration", showDetailsText: "showDetailsText", toastDetails: "toastDetails", errorTranslations: "errorTranslations", showIndicator: "showIndicator", position: "position" }, host: { listeners: { "@openClose.done": "openCloseDone($event)" }, properties: { "@openClose": "this.openClose", "class": "this.conditionaClasses" } }, ngImport: i0, template: "<div class=\"toast-wrapper\">\n  <div\n    class=\"doka-toast-notification\"\n    (click)=\"toastDetails.error ? openErrorDetails() : null\"\n    [ngClass]=\"[\n      'doka-toast-notification-' + type,\n      position === positionEnum.BottomCenter ? 'bottom-0' : ''\n    ]\"\n    #dokaToast\n  >\n    <div class=\"doka-toast-notification-content\">\n      <span class=\"doka-toast-notification-title\">\n        @if(toastDetails.title === null || toastDetails.title === '') {\n        <ng-content select=\"[title]\"></ng-content>\n        } @else {\n        <p>\n          {{ toastDetails.title }}\n        </p>\n        }\n      </span>\n      <span class=\"doka-toast-notification-description\">\n        @if(toastDetails.message === null || toastDetails.message === '') {\n        <ng-content select=\"[text]\"></ng-content>\n        <ng-content></ng-content>\n        } @else {\n        <p *ngIf=\"toastDetails.message\">{{ toastDetails.message }}</p>\n        }\n        <a\n          *ngIf=\"toastDetails.error\"\n          style=\"color: grey; text-decoration: underline\"\n        >\n          {{ showDetailsText }}\n        </a>\n      </span>\n    </div>\n    <button\n      class=\"doka-toast-notification-close\"\n      (click)=\"$event.stopPropagation(); hide()\"\n    ></button>\n    <div\n      *ngIf=\"duration && duration > 0\"\n      class=\"toast-dismiss-progress\"\n      [ngClass]=\"!showIndicator ? 'hidden' : 'flex'\"\n      [@startDismiss]=\"{ value: dismissState, params: { time: duration } }\"\n      (@startDismiss.done)=\"dismissDone($event)\"\n    ></div>\n  </div>\n</div>\n", styles: [":host{position:absolute;display:flex}:host.bottom-centered{left:50%;transform:translate(-50%)}.toast-wrapper{display:flex;flex-flow:row}.toast-dismiss-progress{position:absolute;flex:1;opacity:.3;bottom:0;left:0;height:8px;background:#000;width:100%}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], animations: [
            trigger('openClose', [
                state('closed', style({
                    bottom: '{{closedBottom}}',
                    top: '{{closedTop}}',
                    right: '{{closedRight}}',
                }), { params: { closedBottom: '0', closedTop: '0', closedRight: '0' } }),
                state('open', style({
                    visibility: 'visible',
                    bottom: '{{openedBottom}}',
                    top: '{{openedTop}}',
                    right: '{{openedRight}}',
                }), { params: { openedBottom: '0', openedTop: '0', openedRight: '0' } }),
                transition('open <=> closed', [animate('0.5s ease-in-out')]),
            ]),
            trigger('startDismiss', [
                state('opened', style({
                    width: '100%',
                })),
                state('dismissed', style({
                    width: '0%',
                })),
                transition('opened => dismissed', [animate('{{time}}s')]),
            ]),
        ] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ToastComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-toast', animations: [
                        trigger('openClose', [
                            state('closed', style({
                                bottom: '{{closedBottom}}',
                                top: '{{closedTop}}',
                                right: '{{closedRight}}',
                            }), { params: { closedBottom: '0', closedTop: '0', closedRight: '0' } }),
                            state('open', style({
                                visibility: 'visible',
                                bottom: '{{openedBottom}}',
                                top: '{{openedTop}}',
                                right: '{{openedRight}}',
                            }), { params: { openedBottom: '0', openedTop: '0', openedRight: '0' } }),
                            transition('open <=> closed', [animate('0.5s ease-in-out')]),
                        ]),
                        trigger('startDismiss', [
                            state('opened', style({
                                width: '100%',
                            })),
                            state('dismissed', style({
                                width: '0%',
                            })),
                            transition('opened => dismissed', [animate('{{time}}s')]),
                        ]),
                    ], template: "<div class=\"toast-wrapper\">\n  <div\n    class=\"doka-toast-notification\"\n    (click)=\"toastDetails.error ? openErrorDetails() : null\"\n    [ngClass]=\"[\n      'doka-toast-notification-' + type,\n      position === positionEnum.BottomCenter ? 'bottom-0' : ''\n    ]\"\n    #dokaToast\n  >\n    <div class=\"doka-toast-notification-content\">\n      <span class=\"doka-toast-notification-title\">\n        @if(toastDetails.title === null || toastDetails.title === '') {\n        <ng-content select=\"[title]\"></ng-content>\n        } @else {\n        <p>\n          {{ toastDetails.title }}\n        </p>\n        }\n      </span>\n      <span class=\"doka-toast-notification-description\">\n        @if(toastDetails.message === null || toastDetails.message === '') {\n        <ng-content select=\"[text]\"></ng-content>\n        <ng-content></ng-content>\n        } @else {\n        <p *ngIf=\"toastDetails.message\">{{ toastDetails.message }}</p>\n        }\n        <a\n          *ngIf=\"toastDetails.error\"\n          style=\"color: grey; text-decoration: underline\"\n        >\n          {{ showDetailsText }}\n        </a>\n      </span>\n    </div>\n    <button\n      class=\"doka-toast-notification-close\"\n      (click)=\"$event.stopPropagation(); hide()\"\n    ></button>\n    <div\n      *ngIf=\"duration && duration > 0\"\n      class=\"toast-dismiss-progress\"\n      [ngClass]=\"!showIndicator ? 'hidden' : 'flex'\"\n      [@startDismiss]=\"{ value: dismissState, params: { time: duration } }\"\n      (@startDismiss.done)=\"dismissDone($event)\"\n    ></div>\n  </div>\n</div>\n", styles: [":host{position:absolute;display:flex}:host.bottom-centered{left:50%;transform:translate(-50%)}.toast-wrapper{display:flex;flex-flow:row}.toast-dismiss-progress{position:absolute;flex:1;opacity:.3;bottom:0;left:0;height:8px;background:#000;width:100%}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.ModalController }], propDecorators: { openClose: [{
                type: HostBinding,
                args: ['@openClose']
            }], openCloseDone: [{
                type: HostListener,
                args: ['@openClose.done', ['$event']]
            }], conditionaClasses: [{
                type: HostBinding,
                args: ['class']
            }], type: [{
                type: Input
            }], duration: [{
                type: Input
            }], showDetailsText: [{
                type: Input
            }], toastDetails: [{
                type: Input
            }], errorTranslations: [{
                type: Input
            }], showIndicator: [{
                type: Input
            }], position: [{
                type: Input
            }] } });

class DokaToastService {
    constructor() { }
    init(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
    }
    async create(details, type, duration, showDetailsText, errorDetailsTranslations, position, showIndicator) {
        const toast = this.viewContainerRef.createComponent(ToastComponent);
        toast.instance.type = type ?? null;
        toast.instance.duration = duration;
        toast.instance.toastDetails = details;
        if (showDetailsText)
            toast.instance.showDetailsText = showDetailsText;
        if (errorDetailsTranslations) {
            toast.instance.errorTranslations = { ...toast.instance.errorTranslations, ...errorDetailsTranslations };
        }
        if (position)
            toast.instance.position = position;
        if (showIndicator)
            toast.instance.showIndicator = showIndicator;
        toast.instance.onDismiss.subscribe(() => {
            toast.destroy();
        });
        return new Promise((resolve) => {
            const viewDoneSub = toast.instance.viewSub.subscribe(() => {
                resolve(toast.instance);
                viewDoneSub.unsubscribe();
            });
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaToastService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaToastService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaToastService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [] });

const PlatformType = {
    Web: "web",
    IOS: "ios",
    Android: "android"
};

class PlatformService {
    constructor() {
        this.isUsingCapacitor = false;
        this.platform = PlatformType.Web;
        this.isInitialized = false;
        this.init();
    }
    async init() {
        this.getPlatformWithoutCapacitor();
        this.isInitialized = true;
    }
    getPlatformWithoutCapacitor() {
        console.log(navigator.userAgent);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: PlatformService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: PlatformService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: PlatformService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class DokaCommonService {
    constructor(_dokaBannerService, _dokaSelectService, _dokaToastService, platformService) {
        this._dokaBannerService = _dokaBannerService;
        this._dokaSelectService = _dokaSelectService;
        this._dokaToastService = _dokaToastService;
        this.platformService = platformService;
    }
    init(viewContainerRef) {
        this._dokaBannerService.init(viewContainerRef);
        this._dokaToastService.init(viewContainerRef);
        this._dokaSelectService.init(viewContainerRef);
        this.platformService.init();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaCommonService, deps: [{ token: DokaBannerService }, { token: DokaSelectService }, { token: DokaToastService }, { token: PlatformService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaCommonService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaCommonService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: DokaBannerService }, { type: DokaSelectService }, { type: DokaToastService }, { type: PlatformService }] });

class CommonComponent {
    constructor() { }
    ngOnInit() {
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: CommonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: CommonComponent, selector: "lib-common", ngImport: i0, template: `
    <p>
      common works!
    </p>
  `, isInline: true, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: CommonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-common', template: `
    <p>
      common works!
    </p>
  `, encapsulation: ViewEncapsulation.None }]
        }], ctorParameters: () => [] });

const AvatarSize = {
    XS: "extraSmall",
    Small: "small",
    Medium: "medium",
    Large: "large",
    XL: "extraLarge"
};

class AvatarComponent {
    constructor() {
        this.src = null;
        this.size = AvatarSize.Small;
        this.initials = 'VN';
    }
    ngOnInit() {
        this.initials = this.initials.toUpperCase();
    }
    ngAfterViewInit() {
        switch (this.size) {
            case AvatarSize.Small: {
                this.dokaImg.nativeElement.classList.add('doka-avatar-small');
                this.placeHolder.nativeElement.classList.add('doka-avatar-small');
                break;
            }
            case AvatarSize.XS: {
                this.dokaImg.nativeElement.classList.add('doka-avatar-extra-small');
                this.placeHolder.nativeElement.classList.add('doka-avatar-extra-small');
                break;
            }
            case AvatarSize.Medium: {
                this.dokaImg.nativeElement.classList.add('doka-avatar-medium');
                this.placeHolder.nativeElement.classList.add('doka-avatar-medium');
                break;
            }
            case AvatarSize.Large: {
                this.dokaImg.nativeElement.classList.add('doka-avatar-large');
                this.placeHolder.nativeElement.classList.add('doka-avatar-large');
                break;
            }
            case AvatarSize.XL: {
                this.dokaImg.nativeElement.classList.add('doka-avatar-extra-large');
                this.placeHolder.nativeElement.classList.add('doka-avatar-extra-large');
                break;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: AvatarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: AvatarComponent, selector: "doka-avatar", inputs: { src: "src", size: "size", initials: "initials" }, viewQueries: [{ propertyName: "dokaImg", first: true, predicate: ["dokaImg"], descendants: true }, { propertyName: "placeHolder", first: true, predicate: ["placeHolder"], descendants: true }], ngImport: i0, template: "<img\n  #dokaImg\n  class=\"doka-avatar\"\n  [ngClass]=\"{ 'doka-hidden': !src }\"\n  [src]=\"src ?? null\"\n/>\n<div\n  #placeHolder\n  class=\"doka-avatar doka-avatar-placeholder\"\n  [ngClass]=\"{ 'doka-hidden': src }\"\n>\n  {{ initials }}\n</div>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: AvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-avatar', template: "<img\n  #dokaImg\n  class=\"doka-avatar\"\n  [ngClass]=\"{ 'doka-hidden': !src }\"\n  [src]=\"src ?? null\"\n/>\n<div\n  #placeHolder\n  class=\"doka-avatar doka-avatar-placeholder\"\n  [ngClass]=\"{ 'doka-hidden': src }\"\n>\n  {{ initials }}\n</div>\n" }]
        }], ctorParameters: () => [], propDecorators: { src: [{
                type: Input
            }], size: [{
                type: Input
            }], initials: [{
                type: Input
            }], dokaImg: [{
                type: ViewChild,
                args: ['dokaImg']
            }], placeHolder: [{
                type: ViewChild,
                args: ['placeHolder']
            }] } });

const BadgeIconPosition = {
    Prefix: "prefix",
    Suffix: "suffix"
};

const BadgeSize = {
    Small: 'small',
    Normal: 'normal',
};

const BadgeType = {
    ...UIStyle,
    InformationLight: "light",
    Neutral: "neutral",
    PrimaryYellow: "primary-yellow",
    PrimaryBlue: "primary-blue",
};

class BadgeComponent {
    get ConditionalClasses() {
        return {
            'doka-badge-alert': this.type === BadgeType.Alert,
            'doka-badge-information': this.type === BadgeType.Information,
            'doka-badge-success': this.type === BadgeType.Success,
            'doka-badge-warning': this.type === BadgeType.Warning,
            'doka-badge-small': this.size === BadgeSize.Small,
            [`doka-badge-${this.type}`]: true,
        };
    }
    get TypeClasses() {
        return 'doka-badge-' + this.type;
    }
    constructor() {
        this.size = BadgeSize.Normal;
        this.type = BadgeType.Information;
        this.text = null;
        this.icon = null;
        this.iconPosition = BadgeIconPosition.Prefix;
    }
    ngOnChanges(changes) {
        const typeChange = changes['type'];
        if (isChanged(typeChange)) {
            this.type = typeChange.currentValue;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: BadgeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: BadgeComponent, selector: "doka-badge", inputs: { size: "size", type: "type", text: "text", icon: "icon", iconPosition: "iconPosition" }, host: { properties: { "class": "this.TypeClasses" }, classAttribute: "doka-badge" }, queries: [{ propertyName: "textT", first: true, predicate: ["text"], descendants: true }, { propertyName: "iconT", first: true, predicate: ["icon"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"doka-badge-content cust-doka-badge-content\">\n  <ng-container\n    *ngTemplateOutlet=\"iconPosition === 'prefix' ? iconTemplate : labelTemplate\"\n  ></ng-container>\n  <ng-container\n    *ngTemplateOutlet=\"iconPosition === 'suffix' ? iconTemplate : labelTemplate\"\n  ></ng-container>\n</div>\n\n<ng-template #iconTemplate>\n  <span *ngIf=\"icon || iconT\" icon class=\"doka-badge-icon\">\n    <span *ngIf=\"icon && !iconT\">{{ icon }}</span>\n    <ng-container *ngTemplateOutlet=\"iconT\"></ng-container>\n  </span>\n</ng-template>\n\n<ng-template #labelTemplate>\n  <span class=\"doka-badge-label\" *ngIf=\"text || textT\">\n    <ng-container *ngTemplateOutlet=\"textT\"></ng-container>\n    <p *ngIf=\"text && !textT\"></p>\n  </span>\n  <span class=\"doka-badge-label\" *ngIf=\"!text && !textT\">\n    <ng-content></ng-content>\n  </span>\n</ng-template>\n", styles: [".cust-doka-badge-content{display:flex;flex-flow:row;align-items:center}.doka-badge-icon{color:inherit}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: BadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-badge', host: { class: 'doka-badge' }, template: "<div class=\"doka-badge-content cust-doka-badge-content\">\n  <ng-container\n    *ngTemplateOutlet=\"iconPosition === 'prefix' ? iconTemplate : labelTemplate\"\n  ></ng-container>\n  <ng-container\n    *ngTemplateOutlet=\"iconPosition === 'suffix' ? iconTemplate : labelTemplate\"\n  ></ng-container>\n</div>\n\n<ng-template #iconTemplate>\n  <span *ngIf=\"icon || iconT\" icon class=\"doka-badge-icon\">\n    <span *ngIf=\"icon && !iconT\">{{ icon }}</span>\n    <ng-container *ngTemplateOutlet=\"iconT\"></ng-container>\n  </span>\n</ng-template>\n\n<ng-template #labelTemplate>\n  <span class=\"doka-badge-label\" *ngIf=\"text || textT\">\n    <ng-container *ngTemplateOutlet=\"textT\"></ng-container>\n    <p *ngIf=\"text && !textT\"></p>\n  </span>\n  <span class=\"doka-badge-label\" *ngIf=\"!text && !textT\">\n    <ng-content></ng-content>\n  </span>\n</ng-template>\n", styles: [".cust-doka-badge-content{display:flex;flex-flow:row;align-items:center}.doka-badge-icon{color:inherit}\n"] }]
        }], ctorParameters: () => [], propDecorators: { textT: [{
                type: ContentChild,
                args: ['text', { static: false }]
            }], iconT: [{
                type: ContentChild,
                args: ['icon', { static: false }]
            }], size: [{
                type: Input
            }], type: [{
                type: Input
            }], text: [{
                type: Input
            }], icon: [{
                type: Input
            }], iconPosition: [{
                type: Input
            }], ConditionalClasses: [{
                type: HostBinding,
                args: ['class']
            }], TypeClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

class CardComponent {
    constructor() {
        this.disabled = false;
        this.selected = false;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: CardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: CardComponent, selector: "doka-card", inputs: { disabled: "disabled", selected: "selected" }, ngImport: i0, template: "<button\n  class=\"doka-card doka-card-selectable doka-w-full doka-h-full\"\n  [ngClass]=\"{\n    'doka-card-selected': selected,\n    'doka-card-disabled': disabled\n  }\"\n>\n  <ng-content></ng-content>\n</button>\n", styles: [".doka-card-selectable{border-style:solid}:host{width:fit-content;height:fit-content}.doka-card{height:100%;width:100%}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: CardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-card', template: "<button\n  class=\"doka-card doka-card-selectable doka-w-full doka-h-full\"\n  [ngClass]=\"{\n    'doka-card-selected': selected,\n    'doka-card-disabled': disabled\n  }\"\n>\n  <ng-content></ng-content>\n</button>\n", styles: [".doka-card-selectable{border-style:solid}:host{width:fit-content;height:fit-content}.doka-card{height:100%;width:100%}\n"] }]
        }], ctorParameters: () => [], propDecorators: { disabled: [{
                type: Input
            }], selected: [{
                type: Input
            }] } });

const ChipType = {
    Default: "default",
    Addable: "addable",
    Removable: "removable"
};

class ChipComponent {
    constructor() {
        this.activated = false;
        this.disabled = false;
        this.showIcon = false;
        this.type = ChipType.Default;
        this.chipClicked = new EventEmitter();
        this.sections = {};
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ChipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: ChipComponent, selector: "doka-chip", inputs: { activated: "activated", disabled: "disabled", showIcon: "showIcon", type: "type" }, outputs: { chipClicked: "chipClicked" }, viewQueries: [{ propertyName: "chipButton", first: true, predicate: ["chipButton"], descendants: true }, { propertyName: "sectionElements", predicate: ["[section]"], descendants: true }], ngImport: i0, template: "<div\n  class=\"doka-chip\"\n  [ngClass]=\"{\n    'doka-chip-activated': activated && this.type !== 'addable',\n    'doka-chip-disabled': disabled\n  }\"\n>\n  <span>\n    <ng-content></ng-content>\n  </span>\n  <button\n    class=\"doka-chip-action\"\n    (click)=\"chipClicked.emit($event)\"\n    *ngIf=\"this.type !== 'default'\"\n  >\n    <span\n      [ngClass]=\"{\n        'doka-chip-action-remove': this.type === 'removable',\n        'doka-chip-action-add': this.type === 'addable'\n      }\"\n    ></span>\n  </button>\n</div>\n", styles: [":host.activated-background{background:var(--color-background-highlight);background-color:var(--color-background-highlight)}:host.activated-background:hover{background-color:var(--color-background-highlight-hover)}:host.activated-background:focus{background-color:var(--color-background-highlight-focus)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ChipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-chip', template: "<div\n  class=\"doka-chip\"\n  [ngClass]=\"{\n    'doka-chip-activated': activated && this.type !== 'addable',\n    'doka-chip-disabled': disabled\n  }\"\n>\n  <span>\n    <ng-content></ng-content>\n  </span>\n  <button\n    class=\"doka-chip-action\"\n    (click)=\"chipClicked.emit($event)\"\n    *ngIf=\"this.type !== 'default'\"\n  >\n    <span\n      [ngClass]=\"{\n        'doka-chip-action-remove': this.type === 'removable',\n        'doka-chip-action-add': this.type === 'addable'\n      }\"\n    ></span>\n  </button>\n</div>\n", styles: [":host.activated-background{background:var(--color-background-highlight);background-color:var(--color-background-highlight)}:host.activated-background:hover{background-color:var(--color-background-highlight-hover)}:host.activated-background:focus{background-color:var(--color-background-highlight-focus)}\n"] }]
        }], ctorParameters: () => [], propDecorators: { activated: [{
                type: Input
            }], disabled: [{
                type: Input
            }], showIcon: [{
                type: Input
            }], type: [{
                type: Input
            }], sectionElements: [{
                type: ViewChildren,
                args: ['[section]']
            }], chipClicked: [{
                type: Output
            }], chipButton: [{
                type: ViewChild,
                args: ['chipButton']
            }] } });

class DateInputComponent {
    constructor(_dokaDateTimeService) {
        this._dokaDateTimeService = _dokaDateTimeService;
        this.alert = null;
        this.disabled = false;
        this.readOnly = false;
        this.label = null;
        this.desc = null;
        this.required = false;
        this.valueChange = new EventEmitter();
    }
    async onInput(event) {
        try {
            const vals = event.target.value.split('.');
            console.log(vals);
            this.value = new Date(vals[2], vals[1] - 1, vals[0]);
            this.valueChange.emit(this.value);
        }
        catch (error) {
            console.warn(error);
        }
    }
    async onOpenDatePicker() {
        const res = await this._dokaDateTimeService.open();
        if (res) {
            this.value = new Date(res);
            this.valueChange.emit(this.value);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DateInputComponent, deps: [{ token: i1$2.DokaDateTimeService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.11", type: DateInputComponent, selector: "doka-date-input", inputs: { alert: "alert", disabled: "disabled", readOnly: "readOnly", label: "label", desc: "desc", required: "required", value: "value" }, outputs: { valueChange: "valueChange" }, queries: [{ propertyName: "labelT", first: true, predicate: ["label"], descendants: true }, { propertyName: "descT", first: true, predicate: ["desc"], descendants: true }, { propertyName: "alertT", first: true, predicate: ["alert"], descendants: true }], ngImport: i0, template: "<label class=\"doka-date-input-container\">\n  <span class=\"doka-date-input-label\" *ngIf=\"label || labelT\">\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n  </span>\n  <span *ngIf=\"desc || descT\" class=\"doka-date-input-description\">\n    <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n    <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n  </span>\n  <div class=\"doka-date-input-wrapper\">\n    <input\n      class=\"doka-date-input\"\n      [ngClass]=\"{ 'doka-date-input-required': required }\"\n      placeholder=\"DD.MM.YYYY\"\n      value=\"{{ value | date : 'dd.MM.yyyy' }}\"\n      (blur)=\"onInput($event)\"\n      [disabled]=\"disabled\"\n      [readOnly]=\"readOnly\"\n    />\n    <button\n      class=\"doka-date-input-button\"\n      tabindex=\"-1\"\n      (click)=\"onOpenDatePicker()\"\n    ></button>\n  </div>\n  <span class=\"doka-date-input-alert-message\" *ngIf=\"alert || alertT\">\n    @if(alert && !alertT) {\n    {{ alert }}\n    }\n    <ng-container *ngTemplateOutlet=\"alertT\"></ng-container>\n  </span>\n</label>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "pipe", type: i1.DatePipe, name: "date" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DateInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-date-input', template: "<label class=\"doka-date-input-container\">\n  <span class=\"doka-date-input-label\" *ngIf=\"label || labelT\">\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n  </span>\n  <span *ngIf=\"desc || descT\" class=\"doka-date-input-description\">\n    <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n    <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n  </span>\n  <div class=\"doka-date-input-wrapper\">\n    <input\n      class=\"doka-date-input\"\n      [ngClass]=\"{ 'doka-date-input-required': required }\"\n      placeholder=\"DD.MM.YYYY\"\n      value=\"{{ value | date : 'dd.MM.yyyy' }}\"\n      (blur)=\"onInput($event)\"\n      [disabled]=\"disabled\"\n      [readOnly]=\"readOnly\"\n    />\n    <button\n      class=\"doka-date-input-button\"\n      tabindex=\"-1\"\n      (click)=\"onOpenDatePicker()\"\n    ></button>\n  </div>\n  <span class=\"doka-date-input-alert-message\" *ngIf=\"alert || alertT\">\n    @if(alert && !alertT) {\n    {{ alert }}\n    }\n    <ng-container *ngTemplateOutlet=\"alertT\"></ng-container>\n  </span>\n</label>\n" }]
        }], ctorParameters: () => [{ type: i1$2.DokaDateTimeService }], propDecorators: { labelT: [{
                type: ContentChild,
                args: ['label', { static: false }]
            }], descT: [{
                type: ContentChild,
                args: ['desc', { static: false }]
            }], alertT: [{
                type: ContentChild,
                args: ['alert', { static: false }]
            }], alert: [{
                type: Input
            }], disabled: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], label: [{
                type: Input
            }], desc: [{
                type: Input
            }], required: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }] } });

class DatePickerComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DatePickerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: DatePickerComponent, selector: "lib-date-picker", ngImport: i0, template: "<p>date-picker works!</p>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DatePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-date-picker', template: "<p>date-picker works!</p>\n" }]
        }] });

class EmptyStateComponent {
    constructor() {
        this.icon = null;
        this.title = null;
        this.desc = null;
        this.button = null;
        this.buttonClick = new EventEmitter();
        this.dokaEmptyState = true;
        this.isFaIcon = false;
    }
    ngAfterViewInit() {
        if (this.icon) {
            if (this.icon.includes('fa')) {
                this.isFaIcon = true;
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: EmptyStateComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: EmptyStateComponent, selector: "doka-empty-state", inputs: { icon: "icon", title: "title", desc: "desc", button: "button" }, outputs: { buttonClick: "buttonClick" }, host: { properties: { "class.doka-empty-state": "this.dokaEmptyState" } }, queries: [{ propertyName: "titleT", first: true, predicate: ["title"], descendants: true }, { propertyName: "descT", first: true, predicate: ["desc"], descendants: true }, { propertyName: "buttonT", first: true, predicate: ["button"], descendants: true }], ngImport: i0, template: "<i #faIcon *ngIf=\"icon && isFaIcon\" icon class=\"doka-empty-state-icon\"></i>\n<ion-icon *ngIf=\"icon\" class=\"doka-empty-state-icon\" [name]=\"icon\"></ion-icon>\n<span class=\"doka-empty-state-title\" *ngIf=\"title || titleT\">\n  <ng-container *ngTemplateOutlet=\"titleT\"></ng-container>\n  <p *ngIf=\"title && !titleT\">{{ title }}</p>\n</span>\n<span class=\"doka-empty-state-description\" *ngIf=\"desc || descT\">\n  <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n  <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n</span>\n<button\n  (click)=\"buttonClick.emit($event)\"\n  class=\"doka-button\"\n  *ngIf=\"button || buttonT\"\n>\n  <ng-container *ngTemplateOutlet=\"buttonT\"></ng-container>\n  <p *ngIf=\"button && !buttonT\">{{ button }}</p>\n</button>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: i1$1.IonIcon, selector: "ion-icon", inputs: ["color", "flipRtl", "icon", "ios", "lazy", "md", "mode", "name", "sanitize", "size", "src"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: EmptyStateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-empty-state', template: "<i #faIcon *ngIf=\"icon && isFaIcon\" icon class=\"doka-empty-state-icon\"></i>\n<ion-icon *ngIf=\"icon\" class=\"doka-empty-state-icon\" [name]=\"icon\"></ion-icon>\n<span class=\"doka-empty-state-title\" *ngIf=\"title || titleT\">\n  <ng-container *ngTemplateOutlet=\"titleT\"></ng-container>\n  <p *ngIf=\"title && !titleT\">{{ title }}</p>\n</span>\n<span class=\"doka-empty-state-description\" *ngIf=\"desc || descT\">\n  <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n  <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n</span>\n<button\n  (click)=\"buttonClick.emit($event)\"\n  class=\"doka-button\"\n  *ngIf=\"button || buttonT\"\n>\n  <ng-container *ngTemplateOutlet=\"buttonT\"></ng-container>\n  <p *ngIf=\"button && !buttonT\">{{ button }}</p>\n</button>\n" }]
        }], ctorParameters: () => [], propDecorators: { titleT: [{
                type: ContentChild,
                args: ['title', { static: false }]
            }], descT: [{
                type: ContentChild,
                args: ['desc', { static: false }]
            }], buttonT: [{
                type: ContentChild,
                args: ['button', { static: false }]
            }], icon: [{
                type: Input
            }], title: [{
                type: Input
            }], desc: [{
                type: Input
            }], button: [{
                type: Input
            }], buttonClick: [{
                type: Output
            }], dokaEmptyState: [{
                type: HostBinding,
                args: ['class.doka-empty-state']
            }] } });

class ImagePickerComponent {
    onRemoveImage(event) {
        event.stopPropagation();
        this.image = null;
    }
    constructor(required) {
        this.image = null;
        this.disabled = false;
        this.label = null;
        this.button = null;
        this.alert = null;
        this.required = false;
        this.placeholderUpload = 'Upload';
        this.onGetPicture = new EventEmitter();
        if (required !== null) {
            this.required = true;
        }
    }
    ngAfterContentInit() {
        console.log(this.required);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ImagePickerComponent, deps: [{ token: 'required', attribute: true }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: ImagePickerComponent, selector: "doka-image-picker", inputs: { image: "image", disabled: "disabled", label: "label", button: "button", alert: "alert", required: "required", placeholderUpload: "placeholderUpload" }, outputs: { onGetPicture: "onGetPicture" }, queries: [{ propertyName: "labelT", first: true, predicate: ["label"], descendants: true }, { propertyName: "buttonT", first: true, predicate: ["button"], descendants: true }, { propertyName: "alertT", first: true, predicate: ["alert"], descendants: true }], ngImport: i0, template: "<label class=\"doka-image-picker-container\">\n  <span class=\"doka-image-picker-label\" *ngIf=\"label || labelT\">\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n    <p *ngIf=\"label && !labelT\"></p>\n  </span>\n  <div\n    class=\"doka-image-picker\"\n    [ngClass]=\"{\n      'doka-image-picker-required': required,\n      'doka-image-picker-disabled': disabled\n    }\"\n  >\n    <button\n      *ngIf=\"!image\"\n      (click)=\"!image ? onGetPicture.emit($event) : null\"\n      class=\"doka-image-picker-button\"\n    >\n      <ng-container *ngTemplateOutlet=\"buttonT\"></ng-container>\n      <p *ngIf=\"button && !buttonT\">{{ button }}</p>\n      <p *ngIf=\"!button && !buttonT\">{{ placeholderUpload }}</p>\n    </button>\n    <img *ngIf=\"image\" class=\"doka-image-picker-preview\" [src]=\"image\" />\n    <button\n      *ngIf=\"image\"\n      (click)=\"onRemoveImage($event)\"\n      class=\"doka-image-picker-clear-button doka-pointer-events-none\"\n    ></button>\n  </div>\n  <span *ngIf=\"alert || alertT\" class=\"doka-image-picker-alert-message\">\n    <ng-container *ngTemplateOutlet=\"alertT\"></ng-container>\n    <p *ngIf=\"alert && !alertT\">{{ alert }}</p>\n  </span>\n</label>\n", styles: [".doka-image-picker-button{border-style:solid}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ImagePickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-image-picker', template: "<label class=\"doka-image-picker-container\">\n  <span class=\"doka-image-picker-label\" *ngIf=\"label || labelT\">\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n    <p *ngIf=\"label && !labelT\"></p>\n  </span>\n  <div\n    class=\"doka-image-picker\"\n    [ngClass]=\"{\n      'doka-image-picker-required': required,\n      'doka-image-picker-disabled': disabled\n    }\"\n  >\n    <button\n      *ngIf=\"!image\"\n      (click)=\"!image ? onGetPicture.emit($event) : null\"\n      class=\"doka-image-picker-button\"\n    >\n      <ng-container *ngTemplateOutlet=\"buttonT\"></ng-container>\n      <p *ngIf=\"button && !buttonT\">{{ button }}</p>\n      <p *ngIf=\"!button && !buttonT\">{{ placeholderUpload }}</p>\n    </button>\n    <img *ngIf=\"image\" class=\"doka-image-picker-preview\" [src]=\"image\" />\n    <button\n      *ngIf=\"image\"\n      (click)=\"onRemoveImage($event)\"\n      class=\"doka-image-picker-clear-button doka-pointer-events-none\"\n    ></button>\n  </div>\n  <span *ngIf=\"alert || alertT\" class=\"doka-image-picker-alert-message\">\n    <ng-container *ngTemplateOutlet=\"alertT\"></ng-container>\n    <p *ngIf=\"alert && !alertT\">{{ alert }}</p>\n  </span>\n</label>\n", styles: [".doka-image-picker-button{border-style:solid}\n"] }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Attribute,
                    args: ['required']
                }] }], propDecorators: { labelT: [{
                type: ContentChild,
                args: ['label', { static: false }]
            }], buttonT: [{
                type: ContentChild,
                args: ['button', { static: false }]
            }], alertT: [{
                type: ContentChild,
                args: ['alert', { static: false }]
            }], image: [{
                type: Input
            }], disabled: [{
                type: Input
            }], label: [{
                type: Input
            }], button: [{
                type: Input
            }], alert: [{
                type: Input
            }], required: [{
                type: Input
            }], placeholderUpload: [{
                type: Input
            }], onGetPicture: [{
                type: Output
            }] } });

const InlineNotificationType = UIStyle;

class InlineNotificationComponent {
    get ConditionalClasses() {
        return {
            'doka-inline-notification-information': this.type === InlineNotificationType.Information,
            'doka-inline-notification-alert': this.type === InlineNotificationType.Alert,
            'doka-inline-notification-warning': this.type === InlineNotificationType.Warning,
            'doka-inline-notification-success': this.type === InlineNotificationType.Success,
        };
    }
    constructor(_dokaInlineNotification) {
        this._dokaInlineNotification = _dokaInlineNotification;
        this.title = null;
        this.desc = null;
        this.type = InlineNotificationType.Information;
        this.closable = false;
        this.onClose = new EventEmitter();
    }
    onRemoveElement() {
        this.onClose.emit();
        this._dokaInlineNotification.nativeElement.remove();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: InlineNotificationComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: InlineNotificationComponent, selector: "doka-inline-notification", inputs: { title: "title", desc: "desc", type: "type", closable: "closable" }, outputs: { onClose: "onClose" }, host: { properties: { "class": "this.ConditionalClasses" }, classAttribute: "doka-inline-notification" }, queries: [{ propertyName: "titleT", first: true, predicate: ["title"], descendants: true }, { propertyName: "descT", first: true, predicate: ["desc"], descendants: true }], ngImport: i0, template: "<div class=\"doka-inline-notification-content\">\n  <span class=\"doka-inline-notification-title\" *ngIf=\"title || titleT\">\n    <ng-container *ngTemplateOutlet=\"titleT\"></ng-container>\n    <p *ngIf=\"title && !titleT\">{{ title }}</p>\n  </span>\n  <span class=\"doka-inline-notification-description\" *ngIf=\"desc || descT\">\n    <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n    <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n  </span>\n</div>\n<button\n  *ngIf=\"closable\"\n  class=\"doka-inline-notification-close\"\n  (click)=\"onRemoveElement()\"\n></button>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: InlineNotificationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-inline-notification', host: { class: 'doka-inline-notification' }, template: "<div class=\"doka-inline-notification-content\">\n  <span class=\"doka-inline-notification-title\" *ngIf=\"title || titleT\">\n    <ng-container *ngTemplateOutlet=\"titleT\"></ng-container>\n    <p *ngIf=\"title && !titleT\">{{ title }}</p>\n  </span>\n  <span class=\"doka-inline-notification-description\" *ngIf=\"desc || descT\">\n    <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n    <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n  </span>\n</div>\n<button\n  *ngIf=\"closable\"\n  class=\"doka-inline-notification-close\"\n  (click)=\"onRemoveElement()\"\n></button>\n" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { titleT: [{
                type: ContentChild,
                args: ['title', { static: false }]
            }], descT: [{
                type: ContentChild,
                args: ['desc', { static: false }]
            }], title: [{
                type: Input
            }], desc: [{
                type: Input
            }], type: [{
                type: Input
            }], closable: [{
                type: Input
            }], onClose: [{
                type: Output
            }], ConditionalClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

const ScreenOrientation = {
    Landscape: "landscape",
    Portrait: "portrait"
};

class ScreenService {
    constructor() {
        this.screenOrientationEvent = new Subject();
        this.bindScreenOrientationListeners();
    }
    /**
     * Binds screen Orientation Listeners and sets the ScreenOrientation property and updates the screenOrientation subject
     */
    async bindScreenOrientationListeners() {
        this.detectAndAssignOrientation(screen.orientation.type);
        screen.orientation.addEventListener('change', () => {
            this.detectAndAssignOrientation(screen.orientation.type);
        });
    }
    detectAndAssignOrientation(orientation) {
        if (orientation === 'landscape-primary' || orientation === 'landscape-secondary') {
            this.screenOrientation = ScreenOrientation.Landscape;
        }
        if (orientation === 'portrait-primary' || orientation === 'portrait-secondary') {
            this.screenOrientation = ScreenOrientation.Portrait;
        }
        this.screenOrientationEvent.next(this.screenOrientation);
    }
    ngOnDestroy() {
        screen.orientation.removeEventListener('change', null);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ScreenService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ScreenService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ScreenService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class LandscapeOnlyDirective {
    set isActive(value) {
        this._isActive = value === '' || value === true || value === 'true';
        this.updateView();
    }
    ;
    constructor(template, viewContainer, screenService) {
        this.template = template;
        this.viewContainer = viewContainer;
        this.screenService = screenService;
        this._isActive = true;
    }
    ngOnInit() {
        //test
        this.updateView(this.screenService.screenOrientation);
        this.bindScreenOrientationListeners();
    }
    updateView(orientation) {
        if (!orientation) {
            orientation = this.screenService.screenOrientation;
        }
        if (this._isActive) {
            if (orientation === ScreenOrientation.Landscape) {
                this.createView();
            }
            else {
                this.clearView();
            }
        }
        else {
            this.createView();
        }
    }
    bindScreenOrientationListeners() {
        this.screenOrientSub = this.screenService.screenOrientationEvent.subscribe((screenOrientation) => {
            this.updateView(screenOrientation);
        });
    }
    createView() {
        if (!this.viewReference) {
            this.viewReference = this.viewContainer.createEmbeddedView(this.template);
        }
    }
    clearView() {
        this.viewContainer.clear();
        this.viewReference = null;
    }
    ngOnDestroy() {
        this.screenOrientSub.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: LandscapeOnlyDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: ScreenService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.11", type: LandscapeOnlyDirective, selector: "[landscapeOnly]", inputs: { isActive: ["landscapeOnly", "isActive"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: LandscapeOnlyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[landscapeOnly]',
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: ScreenService }], propDecorators: { isActive: [{
                type: Input,
                args: ['landscapeOnly']
            }] } });

class LinkComponent {
    constructor() {
        this.link = '#';
        this.disabled = false;
        this.external = false;
    }
    get ConditionalClasses() {
        return {
            'doka-link-disabled': this.disabled,
            'doka-link-external': this.external,
        };
    }
    ngAfterViewInit() {
        if (this.disabled) {
            this.dLink.nativeElement.classList.add('doka-link-disabled');
        }
        if (this.external) {
            this.dLink.nativeElement.classList.add('doka-link-external');
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: LinkComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: LinkComponent, selector: "doka-link", inputs: { link: "link", disabled: "disabled", external: "external" }, host: { properties: { "class": "this.ConditionalClasses" } }, viewQueries: [{ propertyName: "dLink", first: true, predicate: ["dLink"], descendants: true }], ngImport: i0, template: "<a\n  #dLink\n  [href]=\"link\"\n  class=\"doka-link\"\n  [ngClass]=\"{ 'doka-link-disabled': disabled }\"\n  target=\"_self\"\n>\n  <ng-content></ng-content>\n</a>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: LinkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-link', template: "<a\n  #dLink\n  [href]=\"link\"\n  class=\"doka-link\"\n  [ngClass]=\"{ 'doka-link-disabled': disabled }\"\n  target=\"_self\"\n>\n  <ng-content></ng-content>\n</a>\n" }]
        }], propDecorators: { link: [{
                type: Input
            }], disabled: [{
                type: Input
            }], external: [{
                type: Input
            }], dLink: [{
                type: ViewChild,
                args: ['dLink']
            }], ConditionalClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

class ModalActionHandlingService {
    constructor() {
        this.dismissAction = new Subject();
        this.disabled = new BehaviorSubject(false);
    }
    getSubmission() {
        return this.dismissAction.asObservable();
    }
    submit() {
        this.dismissAction.next(true);
    }
    close() {
        this.dismissAction.next(false);
    }
    disableApplyButton(value) {
        this.disabled.next(value);
    }
    isApplyButtonDisabled() {
        return this.disabled.asObservable();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ModalActionHandlingService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ModalActionHandlingService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ModalActionHandlingService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [] });

const ModalStyle = {
    ...UIStyle,
    None: "none"
};

var ModalDismissAction;
(function (ModalDismissAction) {
    ModalDismissAction["CANCEL"] = "cancel";
    ModalDismissAction["CONFIRM"] = "confirm";
    ModalDismissAction["CRITICAL_ACTION"] = "critical_action";
})(ModalDismissAction || (ModalDismissAction = {}));
class ModalComponent {
    onKeydown() {
        if (this.dismissable)
            this.dismissModalWithAction(ModalDismissAction.CANCEL);
    }
    constructor(modalCtrl, dynamicService) {
        this.modalCtrl = modalCtrl;
        this.dynamicService = dynamicService;
        this.confirmButtonDisabled = false;
        this.confirm = new EventEmitter();
        this.cancel = new EventEmitter();
        this.criticalAction = new EventEmitter();
        this.modalStyle = ModalStyle.None;
        this.dismissable = true;
        this.dynamicComponent = null;
        this.modalStyleEnum = ModalStyle;
        this.modalAction = ModalDismissAction;
        this.isApplyButtonDisabled$ = this.dynamicService.isApplyButtonDisabled();
    }
    ngOnInit() {
        if (!this.icon)
            this.icon = this.getModalIcon(this.modalStyle);
    }
    getModalIcon(style) {
        switch (style) {
            case ModalStyle.Information:
                return 'info';
            case ModalStyle.Success:
                return 'check_circle';
            case ModalStyle.Warning:
                return 'warning';
            case ModalStyle.Alert:
                return 'error';
            default:
                return undefined;
        }
    }
    get iconStyle() {
        const prefix = 'doka-text-icon-';
        return prefix + this.modalStyle + '-dark';
    }
    async dismissModalWithAction(action) {
        if (this.dismissable && !this.dynamicComponent) {
            await this.modalCtrl.dismiss(undefined, action);
            return;
        }
        if (action === ModalDismissAction.CANCEL) {
            this.cancel.emit();
            this.dynamicService.close();
        }
        else if (action === ModalDismissAction.CONFIRM) {
            this.dynamicService.submit();
            this.confirm.emit();
        }
        else if (action === ModalDismissAction.CRITICAL_ACTION) {
            this.criticalAction.emit();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ModalComponent, deps: [{ token: i1$1.ModalController }, { token: ModalActionHandlingService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: ModalComponent, selector: "doka-modal", inputs: { title: "title", text: "text", innerHTML: "innerHTML", confirmButtonLabel: "confirmButtonLabel", confirmButtonDisabled: "confirmButtonDisabled", cancelButtonLabel: "cancelButtonLabel", criticalActionButtonLabel: "criticalActionButtonLabel", modalStyle: "modalStyle", dismissable: "dismissable", icon: "icon", dynamicComponent: "dynamicComponent", dynamicComponentProps: "dynamicComponentProps" }, outputs: { confirm: "confirm", cancel: "cancel", criticalAction: "criticalAction" }, host: { listeners: { "window:keydown.escape": "onKeydown($event)" } }, providers: [ModalActionHandlingService], ngImport: i0, template: "<div\n  class=\"doka-modal doka-w-full doka-min-w-0 doka-flex-1 sm:doka-max-w-[400px] doka-flex\"\n  [ngClass]=\"'doka-modal-' + this.modalStyle\"\n  efpKeyboardShortcut\n  (escShortcut)=\"dismissModalWithAction(modalAction.CANCEL)\"\n>\n  <div class=\"doka-modal-header-section\">\n    <div class=\"doka-items-stretch doka-modal-header\">\n      <div class=\"doka-modal-header-content\">\n        <span [ngClass]=\"this.iconStyle\" class=\"doka-modal-icon\" *ngIf=\"icon\">{{\n          icon\n        }}</span>\n\n        <span class=\"doka-modal-title\">{{ title }}</span>\n      </div>\n      <div class=\"doka-flex doka-flex-col doka-flex-1 doka-modal-description\">\n        <ng-container *ngIf=\"text\">\n          {{ text }}\n        </ng-container>\n        <div [innerHTML]=\"innerHTML\" *ngIf=\"innerHTML\"></div>\n        <ng-container\n          *ngComponentOutlet=\"dynamicComponent; inputs: dynamicComponentProps\"\n        ></ng-container>\n        <ng-content></ng-content>\n      </div>\n    </div>\n    <button\n      class=\"doka-modal-close\"\n      *ngIf=\"dismissable\"\n      (click)=\"dismissModalWithAction(modalAction.CANCEL)\"\n    ></button>\n  </div>\n\n  <div\n    class=\"doka-modal-content-section\"\n    *ngIf=\"cancelButtonLabel || confirmButtonLabel\"\n  >\n    <div class=\"doka-modal-footer\">\n      <button\n        class=\"doka-button doka-button-secondary doka-modal-action\"\n        *ngIf=\"cancelButtonLabel\"\n        (click)=\"dismissModalWithAction(modalAction.CANCEL)\"\n        data-test-selector=\"simple-modal-cancel\"\n      >\n        {{ cancelButtonLabel }}\n      </button>\n      <button\n        class=\"doka-button doka-button-danger doka-modal-action\"\n        *ngIf=\"criticalActionButtonLabel\"\n        (click)=\"dismissModalWithAction(modalAction.CRITICAL_ACTION)\"\n        data-test-selector=\"simple-modal-critical-action\"\n      >\n        {{ criticalActionButtonLabel }}\n      </button>\n      <ng-container\n        *ngIf=\"{ disabled: this.isApplyButtonDisabled$ | async } as obj\"\n      >\n        <button\n          class=\"doka-button doka-modal-action\"\n          *ngIf=\"confirmButtonLabel\"\n          (click)=\"dismissModalWithAction(modalAction.CONFIRM)\"\n          data-test-selector=\"simple-modal-submit\"\n          [disabled]=\"confirmButtonDisabled || obj.disabled\"\n        >\n          {{ confirmButtonLabel }}\n        </button>\n      </ng-container>\n    </div>\n  </div>\n</div>\n<!-- preload styles -->\n<span\n  class=\"doka-text-icon-warning doka-text-icon-alert doka-text-icon-success doka-text-icon-alert-dark doka-text-icon-success-dark doka-text-icon-warning-dark\"\n></span>\n", styles: [".doka-modal-description{overflow:auto;max-height:60vh}.doka-modal-description::-webkit-scrollbar{width:5px;height:5px}.doka-modal-description::-webkit-scrollbar-track{background:var(--color-background-gray-light)}.doka-modal-description::-webkit-scrollbar-track:hover{background:var(var(--color-background-action-hover))}.doka-modal-description::-webkit-scrollbar-thumb{background:var(--color-background-gray)}.doka-modal-description::-webkit-scrollbar-thumb:hover{background:var(--color-background-gray-strong)}.doka-modal-description .inner-scroll{scrollbar-width:thin}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgComponentOutlet, selector: "[ngComponentOutlet]", inputs: ["ngComponentOutlet", "ngComponentOutletInputs", "ngComponentOutletInjector", "ngComponentOutletContent", "ngComponentOutletNgModule", "ngComponentOutletNgModuleFactory"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-modal', providers: [ModalActionHandlingService], template: "<div\n  class=\"doka-modal doka-w-full doka-min-w-0 doka-flex-1 sm:doka-max-w-[400px] doka-flex\"\n  [ngClass]=\"'doka-modal-' + this.modalStyle\"\n  efpKeyboardShortcut\n  (escShortcut)=\"dismissModalWithAction(modalAction.CANCEL)\"\n>\n  <div class=\"doka-modal-header-section\">\n    <div class=\"doka-items-stretch doka-modal-header\">\n      <div class=\"doka-modal-header-content\">\n        <span [ngClass]=\"this.iconStyle\" class=\"doka-modal-icon\" *ngIf=\"icon\">{{\n          icon\n        }}</span>\n\n        <span class=\"doka-modal-title\">{{ title }}</span>\n      </div>\n      <div class=\"doka-flex doka-flex-col doka-flex-1 doka-modal-description\">\n        <ng-container *ngIf=\"text\">\n          {{ text }}\n        </ng-container>\n        <div [innerHTML]=\"innerHTML\" *ngIf=\"innerHTML\"></div>\n        <ng-container\n          *ngComponentOutlet=\"dynamicComponent; inputs: dynamicComponentProps\"\n        ></ng-container>\n        <ng-content></ng-content>\n      </div>\n    </div>\n    <button\n      class=\"doka-modal-close\"\n      *ngIf=\"dismissable\"\n      (click)=\"dismissModalWithAction(modalAction.CANCEL)\"\n    ></button>\n  </div>\n\n  <div\n    class=\"doka-modal-content-section\"\n    *ngIf=\"cancelButtonLabel || confirmButtonLabel\"\n  >\n    <div class=\"doka-modal-footer\">\n      <button\n        class=\"doka-button doka-button-secondary doka-modal-action\"\n        *ngIf=\"cancelButtonLabel\"\n        (click)=\"dismissModalWithAction(modalAction.CANCEL)\"\n        data-test-selector=\"simple-modal-cancel\"\n      >\n        {{ cancelButtonLabel }}\n      </button>\n      <button\n        class=\"doka-button doka-button-danger doka-modal-action\"\n        *ngIf=\"criticalActionButtonLabel\"\n        (click)=\"dismissModalWithAction(modalAction.CRITICAL_ACTION)\"\n        data-test-selector=\"simple-modal-critical-action\"\n      >\n        {{ criticalActionButtonLabel }}\n      </button>\n      <ng-container\n        *ngIf=\"{ disabled: this.isApplyButtonDisabled$ | async } as obj\"\n      >\n        <button\n          class=\"doka-button doka-modal-action\"\n          *ngIf=\"confirmButtonLabel\"\n          (click)=\"dismissModalWithAction(modalAction.CONFIRM)\"\n          data-test-selector=\"simple-modal-submit\"\n          [disabled]=\"confirmButtonDisabled || obj.disabled\"\n        >\n          {{ confirmButtonLabel }}\n        </button>\n      </ng-container>\n    </div>\n  </div>\n</div>\n<!-- preload styles -->\n<span\n  class=\"doka-text-icon-warning doka-text-icon-alert doka-text-icon-success doka-text-icon-alert-dark doka-text-icon-success-dark doka-text-icon-warning-dark\"\n></span>\n", styles: [".doka-modal-description{overflow:auto;max-height:60vh}.doka-modal-description::-webkit-scrollbar{width:5px;height:5px}.doka-modal-description::-webkit-scrollbar-track{background:var(--color-background-gray-light)}.doka-modal-description::-webkit-scrollbar-track:hover{background:var(var(--color-background-action-hover))}.doka-modal-description::-webkit-scrollbar-thumb{background:var(--color-background-gray)}.doka-modal-description::-webkit-scrollbar-thumb:hover{background:var(--color-background-gray-strong)}.doka-modal-description .inner-scroll{scrollbar-width:thin}\n"] }]
        }], ctorParameters: () => [{ type: i1$1.ModalController }, { type: ModalActionHandlingService }], propDecorators: { title: [{
                type: Input
            }], text: [{
                type: Input
            }], innerHTML: [{
                type: Input
            }], confirmButtonLabel: [{
                type: Input
            }], confirmButtonDisabled: [{
                type: Input
            }], confirm: [{
                type: Output
            }], cancelButtonLabel: [{
                type: Input
            }], cancel: [{
                type: Output
            }], criticalActionButtonLabel: [{
                type: Input
            }], criticalAction: [{
                type: Output
            }], modalStyle: [{
                type: Input
            }], dismissable: [{
                type: Input
            }], icon: [{
                type: Input
            }], dynamicComponent: [{
                type: Input
            }], dynamicComponentProps: [{
                type: Input
            }], onKeydown: [{
                type: HostListener,
                args: ['window:keydown.escape', ['$event']]
            }] } });

const NotificationIndicatorType = {
    Large: "large",
    Small: "small"
};

class NotificationIndicatorComponent {
    get ConditionalClasses() {
        return {
            'doka-notification-indicator-large': this.type === NotificationIndicatorType.Large,
            'doka-notification-indicator-small': this.type === NotificationIndicatorType.Small,
        };
    }
    constructor() {
        this.color = null;
        this.type = NotificationIndicatorType.Large;
    }
    ngAfterViewInit() {
        switch (this.type) {
            case NotificationIndicatorType.Large: {
                this.notificationIndicator.nativeElement.classList.add('doka-notificiation-indicator-large');
                break;
            }
            case NotificationIndicatorType.Small: {
                this.notificationIndicator.nativeElement.classList.add('doka-notification-indicator-small');
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: NotificationIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: NotificationIndicatorComponent, selector: "doka-notification-indicator", inputs: { color: "color", type: "type" }, host: { properties: { "class": "this.ConditionalClasses" } }, viewQueries: [{ propertyName: "notificationIndicator", first: true, predicate: ["notificationIndicator"], descendants: true }], ngImport: i0, template: "<span\n  #notificationIndicator\n  class=\"doka-notification-indicator\"\n  [style.background]=\"color\"\n>\n  <ng-content></ng-content>\n</span>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: NotificationIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-notification-indicator', template: "<span\n  #notificationIndicator\n  class=\"doka-notification-indicator\"\n  [style.background]=\"color\"\n>\n  <ng-content></ng-content>\n</span>\n" }]
        }], ctorParameters: () => [], propDecorators: { color: [{
                type: Input
            }], type: [{
                type: Input
            }], notificationIndicator: [{
                type: ViewChild,
                args: ['notificationIndicator']
            }], ConditionalClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

class NumberInputComponent {
    constructor() {
        this.alert = null;
        this.desc = null;
        this.label = null;
        this.showStep = true;
        this.step = 1;
        this.disabled = false;
        this.required = false;
        this.readOnly = false;
        this.unit = '';
        this.value = 0;
        this.valueChange = new EventEmitter();
        this.trailingDigits = 0;
    }
    ngOnInit() {
        this.step = +this.step;
        const splittedByDot = this.step.toString().split('.');
        console.log(splittedByDot);
        if (splittedByDot.length > 1) {
            this.trailingDigits = splittedByDot[1].length;
            this.value = +this.value;
            console.log(this.trailingDigits);
        }
    }
    onDecrement() {
        this.value = +(+this.value - this.step).toFixed(this.trailingDigits);
        this.valueChange.emit(this.value);
    }
    onIncrement() {
        this.value = +(+this.value + this.step).toFixed(this.trailingDigits);
        this.valueChange.emit(this.value);
    }
    onBlur(event) {
        if (+event.target.value) {
            if (this.value !== event.target.value) {
                this.value = event.target.value;
                this.valueChange.emit(this.value);
            }
        }
        else if (+event.target.value === 0) {
            this.valueChange.emit(0);
        }
        else {
            this.valueChange.emit(undefined);
        }
    }
    onInput(event) {
        if (this.value != event.target.value) {
            this.valueChange.emit(event.target.value);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: NumberInputComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.11", type: NumberInputComponent, selector: "doka-number-input", inputs: { alert: "alert", desc: "desc", label: "label", showStep: "showStep", step: "step", disabled: "disabled", required: "required", readOnly: "readOnly", unit: "unit", value: "value" }, outputs: { valueChange: "valueChange" }, queries: [{ propertyName: "labelT", first: true, predicate: ["label"], descendants: true }, { propertyName: "descT", first: true, predicate: ["desc"], descendants: true }, { propertyName: "alertT", first: true, predicate: ["alert"], descendants: true }, { propertyName: "unitT", first: true, predicate: ["unit"], descendants: true }], viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }], ngImport: i0, template: "<label class=\"doka-number-input-container\">\n  <div class=\"step-counter\" *ngIf=\"showStep && step\">\n    {{ step }}\n  </div>\n  <span class=\"doka-number-input-label\" *ngIf=\"label || labelT\">\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n  </span>\n  <span class=\"doka-number-input-description\" *ngIf=\"desc || descT\">\n    <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n    <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n  </span>\n  <div\n    class=\"doka-number-input-input\"\n    [ngClass]=\"{ 'doka-number-input-required': required }\"\n  >\n    <input\n      #input\n      [value]=\"value\"\n      (input)=\"onInput($event)\"\n      (blur)=\"onBlur($event)\"\n      [disabled]=\"disabled\"\n      [readOnly]=\"readOnly\"\n      [inputMode]=\"step < 1 ? 'numberic' : 'decimal'\"\n      type=\"number\"\n      class=\"doka-number-input\"\n      placeholder=\"0\"\n      [step]=\"step.toString()\"\n    />\n    <span class=\"doka-number-input-decoration\" *ngIf=\"unit || unitT\">\n      @if(unit && !unitT) {\n      {{ unit }}\n      }\n      <ng-container *ngTemplateOutlet=\"unitT\"></ng-container>\n    </span>\n    <div class=\"doka-number-input-controls\" *ngIf=\"showStep\">\n      <button\n        class=\"doka-number-input-button doka-number-input-button-increment\"\n        (click)=\"onIncrement()\"\n        tabindex=\"-1\"\n      ></button>\n      <button\n        class=\"doka-number-input-button doka-number-input-button-decrement\"\n        (click)=\"onDecrement()\"\n        tabindex=\"-1\"\n      ></button>\n    </div>\n  </div>\n  <span class=\"doka-number-input-alert-message\" *ngIf=\"alert || alertT\">\n    <ng-container *ngTemplateOutlet=\"alertT\"></ng-container>\n    @if(alert && !alertT) {\n    {{ alert }}\n    }\n  </span>\n</label>\n", styles: [".step-counter{position:absolute;right:var(--spacing-xl);top:var(--spacing-base)}.input-label-cont{display:flex;flex-flow:row;justify-content:space-between}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: NumberInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-number-input', template: "<label class=\"doka-number-input-container\">\n  <div class=\"step-counter\" *ngIf=\"showStep && step\">\n    {{ step }}\n  </div>\n  <span class=\"doka-number-input-label\" *ngIf=\"label || labelT\">\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n  </span>\n  <span class=\"doka-number-input-description\" *ngIf=\"desc || descT\">\n    <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n    <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n  </span>\n  <div\n    class=\"doka-number-input-input\"\n    [ngClass]=\"{ 'doka-number-input-required': required }\"\n  >\n    <input\n      #input\n      [value]=\"value\"\n      (input)=\"onInput($event)\"\n      (blur)=\"onBlur($event)\"\n      [disabled]=\"disabled\"\n      [readOnly]=\"readOnly\"\n      [inputMode]=\"step < 1 ? 'numberic' : 'decimal'\"\n      type=\"number\"\n      class=\"doka-number-input\"\n      placeholder=\"0\"\n      [step]=\"step.toString()\"\n    />\n    <span class=\"doka-number-input-decoration\" *ngIf=\"unit || unitT\">\n      @if(unit && !unitT) {\n      {{ unit }}\n      }\n      <ng-container *ngTemplateOutlet=\"unitT\"></ng-container>\n    </span>\n    <div class=\"doka-number-input-controls\" *ngIf=\"showStep\">\n      <button\n        class=\"doka-number-input-button doka-number-input-button-increment\"\n        (click)=\"onIncrement()\"\n        tabindex=\"-1\"\n      ></button>\n      <button\n        class=\"doka-number-input-button doka-number-input-button-decrement\"\n        (click)=\"onDecrement()\"\n        tabindex=\"-1\"\n      ></button>\n    </div>\n  </div>\n  <span class=\"doka-number-input-alert-message\" *ngIf=\"alert || alertT\">\n    <ng-container *ngTemplateOutlet=\"alertT\"></ng-container>\n    @if(alert && !alertT) {\n    {{ alert }}\n    }\n  </span>\n</label>\n", styles: [".step-counter{position:absolute;right:var(--spacing-xl);top:var(--spacing-base)}.input-label-cont{display:flex;flex-flow:row;justify-content:space-between}\n"] }]
        }], propDecorators: { labelT: [{
                type: ContentChild,
                args: ['label', { static: false }]
            }], descT: [{
                type: ContentChild,
                args: ['desc', { static: false }]
            }], alertT: [{
                type: ContentChild,
                args: ['alert', { static: false }]
            }], unitT: [{
                type: ContentChild,
                args: ['unit', { static: false }]
            }], alert: [{
                type: Input
            }], desc: [{
                type: Input
            }], label: [{
                type: Input
            }], showStep: [{
                type: Input
            }], step: [{
                type: Input
            }], disabled: [{
                type: Input
            }], required: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], unit: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], input: [{
                type: ViewChild,
                args: ['input']
            }] } });

class PortraitOnlyDirective {
    set isActive(value) {
        this._isActive = value === '' || value === true || value === 'true';
        this.updateView();
    }
    ;
    constructor(template, viewContainer, screenService) {
        this.template = template;
        this.viewContainer = viewContainer;
        this.screenService = screenService;
        this._isActive = true;
    }
    ngOnInit() {
        this.updateView(this.screenService.screenOrientation);
        this.bindScreenOrientationListeners();
    }
    updateView(orientation) {
        if (!orientation) {
            orientation = this.screenService.screenOrientation;
        }
        if (this._isActive) {
            if (orientation === ScreenOrientation.Portrait) {
                this.createView();
            }
            else {
                this.clearView();
            }
        }
        else {
            this.createView();
        }
    }
    bindScreenOrientationListeners() {
        this.screenOrientSub = this.screenService.screenOrientationEvent.subscribe((screenOrientation) => {
            this.updateView(screenOrientation);
        });
    }
    createView() {
        if (!this.viewReference) {
            this.viewReference = this.viewContainer.createEmbeddedView(this.template);
        }
    }
    clearView() {
        this.viewContainer.clear();
        this.viewReference = null;
    }
    ngOnDestroy() {
        this.screenOrientSub.unsubscribe();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: PortraitOnlyDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: ScreenService }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.11", type: PortraitOnlyDirective, selector: "[portraitOnly]", inputs: { isActive: ["portraitOnly", "isActive"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: PortraitOnlyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[portraitOnly]',
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: ScreenService }], propDecorators: { isActive: [{
                type: Input,
                args: ['portraitOnly']
            }] } });

const ProgressBarType = {
    Default: "default",
    Small: "small"
};

class ProgressBarComponent {
    constructor() {
        this.label = null;
        this.color = null;
        this.progress = 0;
        this.status = null;
        this.type = ProgressBarType.Default;
    }
    get ConditionalClasses() {
        return {
            'doka-progress-bar-default': this.type === ProgressBarType.Default,
            'doka-progress-bar-small': this.type === ProgressBarType.Small,
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ProgressBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: ProgressBarComponent, selector: "doka-progress-bar", inputs: { label: "label", color: "color", progress: "progress", status: "status", type: "type" }, host: { properties: { "class": "this.ConditionalClasses" } }, queries: [{ propertyName: "labelT", first: true, predicate: ["label"], descendants: true }], viewQueries: [{ propertyName: "progressBar", first: true, predicate: ["progressBar"], descendants: true }], ngImport: i0, template: "<label class=\"doka-progress-bar-container\">\n  <span class=\"doka-progress-bar-label\" *ngIf=\"label || labelT\">\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n  </span>\n  <div #progressBar class=\"doka-progress-bar\">\n    <div\n      class=\"doka-progress-bar-indicator\"\n      [style.width]=\"progress + '%'\"\n      [style.background]=\"color\"\n    ></div>\n  </div>\n  <span class=\"doka-progress-bar-status\" *ngIf=\"status\">{{ status }}</span>\n</label>\n", styles: [".doka-progress-bar-indicator{transition:width 1s}.doka-progress-bar-label{display:flex;width:100%}:host{height:fit-content;width:100%}.doka-progress-bar{display:flex;min-width:80px;width:100%}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ProgressBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-progress-bar', template: "<label class=\"doka-progress-bar-container\">\n  <span class=\"doka-progress-bar-label\" *ngIf=\"label || labelT\">\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n  </span>\n  <div #progressBar class=\"doka-progress-bar\">\n    <div\n      class=\"doka-progress-bar-indicator\"\n      [style.width]=\"progress + '%'\"\n      [style.background]=\"color\"\n    ></div>\n  </div>\n  <span class=\"doka-progress-bar-status\" *ngIf=\"status\">{{ status }}</span>\n</label>\n", styles: [".doka-progress-bar-indicator{transition:width 1s}.doka-progress-bar-label{display:flex;width:100%}:host{height:fit-content;width:100%}.doka-progress-bar{display:flex;min-width:80px;width:100%}\n"] }]
        }], propDecorators: { labelT: [{
                type: ContentChild,
                args: ['label', { static: false }]
            }], label: [{
                type: Input
            }], color: [{
                type: Input
            }], progress: [{
                type: Input
            }], status: [{
                type: Input
            }], type: [{
                type: Input
            }], progressBar: [{
                type: ViewChild,
                args: ['progressBar']
            }], ConditionalClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });

class RadioButtonComponent {
    constructor() {
        this.desc = null;
        this.disabled = false;
        this.checked = false;
        this.label = null;
        this.value = null;
        this.checkedChange = new EventEmitter();
    }
    ngAfterViewInit() { }
    onCheckedChange(event) {
        this.checked = event.target.checked;
        this.checkedChange.emit(this.checked);
    }
    ngOnChanges(changes) {
        if (changes['checked'] &&
            changes['checked'].currentValue !== changes['checked'].previousValue &&
            !changes['checked'].firstChange) {
            console.log('going there');
            this.checked = changes['checked'].currentValue;
            this.checkedChange.emit(this.checked);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: RadioButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: RadioButtonComponent, selector: "doka-radio-button", inputs: { desc: "desc", disabled: "disabled", checked: "checked", label: "label", value: "value" }, outputs: { checkedChange: "checkedChange" }, queries: [{ propertyName: "descT", first: true, predicate: ["desc"], descendants: true }, { propertyName: "labelT", first: true, predicate: ["label"], descendants: true }], viewQueries: [{ propertyName: "input", first: true, predicate: ["input"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<label class=\"doka-radio-button-container\">\n  <input\n    #input\n    [disabled]=\"disabled\"\n    class=\"doka-radio-button\"\n    [checked]=\"checked\"\n    (change)=\"onCheckedChange($event)\"\n    type=\"radio\"\n  />\n  <span class=\"doka-radio-button-label\" *ngIf=\"label || labelT\">\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n  </span>\n  <span class=\"doka-radio-button-description\" *ngIf=\"desc || descT\">\n    <p *ngIf=\"desc && !descT\">\n      {{ desc }}\n    </p>\n    <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n  </span>\n</label>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: RadioButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-radio-button', template: "<label class=\"doka-radio-button-container\">\n  <input\n    #input\n    [disabled]=\"disabled\"\n    class=\"doka-radio-button\"\n    [checked]=\"checked\"\n    (change)=\"onCheckedChange($event)\"\n    type=\"radio\"\n  />\n  <span class=\"doka-radio-button-label\" *ngIf=\"label || labelT\">\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n  </span>\n  <span class=\"doka-radio-button-description\" *ngIf=\"desc || descT\">\n    <p *ngIf=\"desc && !descT\">\n      {{ desc }}\n    </p>\n    <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n  </span>\n</label>\n" }]
        }], propDecorators: { descT: [{
                type: ContentChild,
                args: ['desc', { static: false }]
            }], labelT: [{
                type: ContentChild,
                args: ['label', { static: false }]
            }], desc: [{
                type: Input
            }], disabled: [{
                type: Input
            }], checked: [{
                type: Input
            }], label: [{
                type: Input
            }], value: [{
                type: Input
            }], checkedChange: [{
                type: Output
            }], input: [{
                type: ViewChild,
                args: ['input']
            }] } });

class RadioButtonGroupComponent {
    constructor() {
        this.desc = null;
        this.label = null;
        this.multi = false;
        this.selected = [];
    }
    onCheckedChange(event, radio) {
        console.log(event);
        if (event) {
            if (!this.multi) {
                this.selected = [];
            }
            this.selected.push(radio.value);
        }
        else {
            radio.checked = false;
            this.selected = this.selected.filter((sel) => sel !== radio.value);
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: RadioButtonGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.11", type: RadioButtonGroupComponent, selector: "doka-radio-button-group", inputs: { desc: "desc", label: "label", multi: "multi", radios: "radios", selected: "selected" }, queries: [{ propertyName: "descT", first: true, predicate: ["desc"], descendants: true }, { propertyName: "labelT", first: true, predicate: ["label"], descendants: true }], ngImport: i0, template: "<fieldset class=\"doka-radio-button-group\">\n  <legend class=\"doka-radio-button-group-heading\">\n    <span class=\"doka-radio-button-group-label\" *ngIf=\"label || labelT\">\n      <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n      <p *ngIf=\"label && !labelT\">{{ label }}</p>\n    </span>\n    <span class=\"doka-radio-button-group-description\" *ngIf=\"desc || descT\">\n      <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n      <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n    </span>\n  </legend>\n  <div class=\"doka-radio-button-group-content\">\n    <ng-content select=\"[radios]\"></ng-content>\n    @if(radios && radios.length > 0) {\n    <doka-radio-button\n      *ngFor=\"let radio of radios\"\n      [disabled]=\"radio.disabled\"\n      (checkedChange)=\"onCheckedChange($event, radio)\"\n      [(checked)]=\"radio.checked\"\n      [desc]=\"radio.desc\"\n    >\n      {{ radio.label }}\n    </doka-radio-button>\n    }\n  </div>\n</fieldset>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: RadioButtonComponent, selector: "doka-radio-button", inputs: ["desc", "disabled", "checked", "label", "value"], outputs: ["checkedChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: RadioButtonGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-radio-button-group', template: "<fieldset class=\"doka-radio-button-group\">\n  <legend class=\"doka-radio-button-group-heading\">\n    <span class=\"doka-radio-button-group-label\" *ngIf=\"label || labelT\">\n      <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n      <p *ngIf=\"label && !labelT\">{{ label }}</p>\n    </span>\n    <span class=\"doka-radio-button-group-description\" *ngIf=\"desc || descT\">\n      <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n      <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n    </span>\n  </legend>\n  <div class=\"doka-radio-button-group-content\">\n    <ng-content select=\"[radios]\"></ng-content>\n    @if(radios && radios.length > 0) {\n    <doka-radio-button\n      *ngFor=\"let radio of radios\"\n      [disabled]=\"radio.disabled\"\n      (checkedChange)=\"onCheckedChange($event, radio)\"\n      [(checked)]=\"radio.checked\"\n      [desc]=\"radio.desc\"\n    >\n      {{ radio.label }}\n    </doka-radio-button>\n    }\n  </div>\n</fieldset>\n" }]
        }], propDecorators: { descT: [{
                type: ContentChild,
                args: ['desc', { static: false }]
            }], labelT: [{
                type: ContentChild,
                args: ['label', { static: false }]
            }], desc: [{
                type: Input
            }], label: [{
                type: Input
            }], multi: [{
                type: Input
            }], radios: [{
                type: Input
            }], selected: [{
                type: Input
            }] } });

class SelectOptionComponent {
    constructor() {
        this.searchValue = null;
        this.checked = false;
        this.checkedChange = new EventEmitter();
        /**
         * Indicates whether the select option allows multiple selections.
         *
         * @type {boolean}
         * @default false
         */
        this.isMulti = false;
    }
    onCheckedChange(value) {
        console.log("This option was checked");
        this.checked = value;
        this.checkedChange.emit(this.checked);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SelectOptionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.11", type: SelectOptionComponent, selector: "doka-select-option", inputs: { value: "value", label: "label", searchValue: "searchValue", checked: "checked" }, outputs: { checkedChange: "checkedChange" }, host: { classAttribute: "doka-select-dropdown-entry" }, queries: [{ propertyName: "content", first: true, predicate: ["content"], descendants: true, static: true }], viewQueries: [{ propertyName: "template", first: true, predicate: ["template"], descendants: true, static: true }], ngImport: i0, template: "<ng-template #template>\n  <div\n    class=\"doka-flex doka-flex-1 doka-h-full doka-flex-row doka-gap-base doka-items-center doka-w-full checkbox-container\"\n  >\n    <doka-checkbox\n      *ngIf=\"isMulti\"\n      [expand]=\"true\"\n      [checked]=\"checked\"\n      (checkedChange)=\"onCheckedChange($event)\"\n      class=\"doka-select-none doka-h-full doka-w-full doka-flex-1 doka-flex\"\n    >\n      <ng-template #label>\n        <ng-container *ngIf=\"content; else noContent\">\n          <ng-container\n            #searchContainer\n            [ngTemplateOutlet]=\"content\"\n          ></ng-container>\n        </ng-container>\n      </ng-template>\n    </doka-checkbox>\n    @if(!isMulti) {\n    <ng-container *ngIf=\"content; else noContent\">\n      <ng-container\n        #searchContainer\n        [ngTemplateOutlet]=\"content\"\n      ></ng-container>\n    </ng-container>\n    }\n  </div>\n</ng-template>\n\n<ng-template #noContent>\n  <p>\n    {{ label }}\n  </p>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: CheckboxComponent, selector: "doka-checkbox", inputs: ["alert", "expand", "checked", "desc", "disabled", "label", "inderminate"], outputs: ["checkedChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SelectOptionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-select-option', host: { class: 'doka-select-dropdown-entry' }, template: "<ng-template #template>\n  <div\n    class=\"doka-flex doka-flex-1 doka-h-full doka-flex-row doka-gap-base doka-items-center doka-w-full checkbox-container\"\n  >\n    <doka-checkbox\n      *ngIf=\"isMulti\"\n      [expand]=\"true\"\n      [checked]=\"checked\"\n      (checkedChange)=\"onCheckedChange($event)\"\n      class=\"doka-select-none doka-h-full doka-w-full doka-flex-1 doka-flex\"\n    >\n      <ng-template #label>\n        <ng-container *ngIf=\"content; else noContent\">\n          <ng-container\n            #searchContainer\n            [ngTemplateOutlet]=\"content\"\n          ></ng-container>\n        </ng-container>\n      </ng-template>\n    </doka-checkbox>\n    @if(!isMulti) {\n    <ng-container *ngIf=\"content; else noContent\">\n      <ng-container\n        #searchContainer\n        [ngTemplateOutlet]=\"content\"\n      ></ng-container>\n    </ng-container>\n    }\n  </div>\n</ng-template>\n\n<ng-template #noContent>\n  <p>\n    {{ label }}\n  </p>\n</ng-template>\n" }]
        }], ctorParameters: () => [], propDecorators: { template: [{
                type: ViewChild,
                args: ['template', { static: true }]
            }], content: [{
                type: ContentChild,
                args: ['content', { static: true }]
            }], value: [{
                type: Input,
                args: [{ required: true }]
            }], label: [{
                type: Input,
                args: [{ required: true }]
            }], searchValue: [{
                type: Input
            }], checked: [{
                type: Input
            }], checkedChange: [{
                type: Output
            }] } });

class SelectComponent {
    constructor(commonService, hostEl, selectService, zone) {
        this.commonService = commonService;
        this.hostEl = hostEl;
        this.selectService = selectService;
        this.zone = zone;
        this.desc = null;
        this.disabled = false;
        this.isMultiSelect = false;
        this.cancelButtonText = 'Cancel';
        this.confirmButtonText = 'Select';
        this.readonly = false;
        this.required = false;
        this.placeholder = 'Select';
        this.placeholderSearchBar = 'Search';
        this.showAsModal = false;
        this.showCloseRow = false;
        this.showSearchBar = false;
        this.value = this.isMultiSelect
            ? []
            : null;
        this.valueChange = new EventEmitter();
        this.dropdownWidth = '0px';
        this.hasLabel2 = false;
        this.isWrapperFocused = false;
        this.isDropDownFocused = false;
        /**
         * Indicates whether a selection is being removed.
         * This flag is used to prevent the dropdown from opening
         * when the user clicks on a chip to remove it.
         */
        this.isRemovingSelection = false;
        this.isSearchBarFocused = false;
        this.checkedSubs = [];
        this.isOpeningModal = false;
        this.modal = null;
        this.searchText = null;
        this.showEntries = false;
        this.interimValues = [];
        document.addEventListener('click', (event) => {
            // Used for closing the dropdown when clicking outside of the select.
            if (!this.wrapper.nativeElement.contains(event.target)) {
                // I needed zone run here because I had some problems with the change detection on android only.
                this.zone.run(() => {
                    this.showEntries = false;
                });
            }
        });
    }
    ngAfterContentInit() {
        if (this.isMultiSelect && !Array.isArray(this.value) && this.value) {
            this.value = [this.value];
        }
        this.setIsMultiInOptions();
        this.setIsCheckedInOptions();
        if (this.isMultiSelect) {
            this.bindChangeEvents();
        }
    }
    ngOnDestroy() {
        this.unsubscribeAll();
    }
    getValueLabel(val) {
        if (this.selectOptions) {
            const selectedEnt = this.selectOptions.find((opt) => opt.value == val);
            if (selectedEnt) {
                return selectedEnt.label;
            }
        }
    }
    getWidth() {
        this.dropdownWidth = this.hostEl.nativeElement.offsetWidth;
    }
    onChangeInputValue(value) {
        this.value = value;
    }
    onSearchChanged(event) {
        this.search(event.target.value);
    }
    ngAfterViewInit() {
        this.wrapper.nativeElement.addEventListener('click', () => {
            if (!this.isRemovingSelection && !this.disabled && !this.readonly) {
                // I needed zone run here because I had some problems with the change detection on android only.
                this.zone.run(() => {
                    if (this.showAsModal && !this.isOpeningModal) {
                        this.openAsModal();
                    }
                    else {
                        if (this.showEntries == false) {
                            this.searchText = null;
                        }
                        this.showEntries = true;
                    }
                });
            }
        });
        if (this.isMultiSelect) {
            if (this.value && Array.isArray(this.value)) {
                this.interimValues = this.value;
            }
            else {
                this.value = [];
            }
        }
    }
    ngOnChanges(changes) {
        if (changes['value']) {
            if (changes['value'].currentValue != changes['value'].previousValue) {
                this.value = changes['value'].currentValue;
            }
            this.setIsCheckedInOptions();
        }
    }
    search(value) {
        this.searchText = value.toLowerCase();
    }
    onSelectOption(option) {
        if (this.isMultiSelect && Array.isArray(this.value)) {
            if (this.value.includes(option.value)) {
                option.checked = false;
                this.value = this.value.filter((val) => val !== option.value);
            }
            else {
                option.checked = true;
                this.value.push(option.value);
                this.valueChange.emit(this.value);
            }
        }
        else {
            this.value = option.value;
            this.valueChange.emit(this.value);
            setTimeout(() => {
                this.showEntries = false;
            }, 10);
        }
    }
    setIsMultiInOptions() {
        this.selectOptions.forEach((opt) => {
            opt.isMulti = this.isMultiSelect;
        });
    }
    setIsCheckedInOptions() {
        if (this.selectOptions) {
            this.selectOptions.forEach((opt) => {
                if (Array.isArray(this.value)) {
                    const val = this.value.find((v) => v == opt.value);
                    opt.checked = !!val;
                }
                else {
                    opt.checked = this.value == opt.value;
                }
            });
        }
    }
    isValueArray() {
        return Array.isArray(this.value);
    }
    removeSelection(event, value) {
        this.isRemovingSelection = true;
        const opt = this.selectOptions.find((opt) => opt.value == value);
        if (opt) {
            opt.checked = false;
        }
        if (Array.isArray(this.value)) {
            this.value = this.value.filter((val) => val !== value);
        }
        this.valueChange.emit(this.value);
        setTimeout(() => {
            this.isRemovingSelection = false;
        }, 10);
    }
    getSearchOptions() {
        return this.selectOptions.filter((opt) => {
            if (opt.label.toLowerCase().includes(this.searchText)) {
                return true;
            }
            if (opt.searchValue) {
                if (opt.searchValue.toLowerCase().includes(this.searchText)) {
                    return true;
                }
            }
        });
    }
    isValueEmpty() {
        if (this.isMultiSelect) {
            if (this.value && Array.isArray(this.value)) {
                return this.value.length === 0;
            }
        }
        else {
            return !this.value;
        }
    }
    async openAsModal() {
        this.isOpeningModal = true;
        this.setIsCheckedInOptions();
        const modalOpts = this.selectOptions.map((so) => {
            return {
                checked: so.checked,
                value: so.value,
                label: so.label,
                searchValue: so.searchValue,
                content: so.content,
            };
        });
        this.modal = await this.selectService.create(modalOpts, this.isMultiSelect, this.showSearchBar, this.label, this.placeholderSearchBar, this.cancelButtonText, this.confirmButtonText);
        setTimeout(() => {
            this.isOpeningModal = false;
        }, 10);
        const res = await this.modal.onDidDismiss();
        if (res && res.length > 0) {
            if (this.isMultiSelect) {
                this.value = res.map((entry) => entry.value);
                this.valueChange.emit(this.value);
                for (const opt of this.selectOptions) {
                    if (Array.isArray(this.value)) {
                        opt.checked = this.value.includes(opt.value);
                    }
                }
            }
            else {
                this.value = res[0].value;
                this.valueChange.emit(this.value);
                for (const opt of this.selectOptions) {
                    opt.checked = opt.value == this.value;
                }
            }
        }
    }
    getValueArray() {
        if (this.value) {
            return Array.isArray(this.value) ? this.value : [this.value];
        }
        return [];
    }
    bindChangeEvents() {
        for (const opt of this.selectOptions) {
            this.checkedSubs.push(opt.checkedChange.subscribe((value) => {
                if (value) {
                    if (Array.isArray(this.value)) {
                        this.value.push(opt.value);
                    }
                }
                else {
                    if (Array.isArray(this.value)) {
                        this.value = this.value.filter((val) => val !== opt.value);
                    }
                }
            }));
        }
    }
    unsubscribeAll() {
        for (const sub of this.checkedSubs) {
            sub.unsubscribe();
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SelectComponent, deps: [{ token: DokaCommonService }, { token: i0.ElementRef }, { token: DokaSelectService }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "18.2.11", type: SelectComponent, selector: "doka-select", inputs: { desc: "desc", disabled: "disabled", isMultiSelect: "isMultiSelect", cancelButtonText: "cancelButtonText", confirmButtonText: "confirmButtonText", label: "label", readonly: "readonly", required: "required", placeholder: "placeholder", placeholderSearchBar: "placeholderSearchBar", showAsModal: "showAsModal", showCloseRow: "showCloseRow", showSearchBar: "showSearchBar", value: "value" }, outputs: { valueChange: "valueChange" }, queries: [{ propertyName: "labelT", first: true, predicate: ["label"], descendants: true }, { propertyName: "descT", first: true, predicate: ["desc"], descendants: true }, { propertyName: "selectOptions", predicate: SelectOptionComponent, descendants: true }], viewQueries: [{ propertyName: "dropdown", first: true, predicate: ["dropdown"], descendants: true }, { propertyName: "wrapper", first: true, predicate: ["wrapper"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<label class=\"doka-select-container\">\n  <span class=\"doka-select-label\" *ngIf=\"label || labelT\">\n    @if(label && !labelT) {\n    {{ label }}\n    }\n    <ng-container [ngTemplateOutlet]=\"labelT\"></ng-container>\n  </span>\n  <span class=\"doka-select-description\" *ngIf=\"desc || descT\">\n    <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n    <ng-container [ngTemplateOutlet]=\"descT\"></ng-container>\n  </span>\n  <div class=\"doka-select-wrapper\" #wrapper>\n    <div\n      class=\"doka-select\"\n      [ngClass]=\"{\n        'doka-select-required': required,\n        'doka-select-disabled': disabled,\n        'doka-select-readonly': readonly\n      }\"\n    >\n      <div class=\"doka-select-chip-container\" *ngIf=\"isMultiSelect\">\n        <!--  -->\n        <p *ngIf=\"isValueEmpty()\" class=\"doka-text-text-disabled\">\n          {{ placeholder }}\n        </p>\n        @for(val of getValueArray(); track val) {\n        <div class=\"doka-chip\">\n          <span>\n            {{ getValueLabel(val) }}\n          </span>\n          <button class=\"doka-chip-action\">\n            <span\n              (click)=\"\n                removeSelection($event, val);\n                $event.preventDefault();\n                $event.stopPropagation()\n              \"\n              class=\"doka-chip-action-remove\"\n            ></span>\n          </button>\n        </div>\n        }\n      </div>\n      <input\n        [ngClass]=\"{ 'doka-hidden': isMultiSelect }\"\n        class=\"doka-select-input\"\n        [value]=\"!isValueArray() && value ? getValueLabel(value) : ''\"\n        [placeholder]=\"placeholder\"\n        [readOnly]=\"true\"\n      />\n    </div>\n    <ul\n      class=\"doka-select-dropdown\"\n      #dropdown\n      *ngIf=\"showEntries && !showAsModal\"\n    >\n      <div class=\"doka-search-field-container\" *ngIf=\"showSearchBar\">\n        <div class=\"doka-search-field-input\">\n          <input\n            #searchBar\n            type=\"text\"\n            class=\"doka-search-field\"\n            [placeholder]=\"placeholderSearchBar\"\n            (input)=\"onSearchChanged($event)\"\n          />\n          <button\n            class=\"doka-search-field-clearButton\"\n            (click)=\"search(''); $event.stopPropagation()\"\n            tabindex=\"-1\"\n          ></button>\n        </div>\n      </div>\n      @for(option of searchText ? getSearchOptions() : selectOptions; track\n      option) {\n      <li\n        *ngIf=\"isMultiSelect\"\n        class=\"doka-select-dropdown-entry md:doka-min-h-14\"\n      >\n        <ng-container [ngTemplateOutlet]=\"option.template\"></ng-container>\n      </li>\n      <li\n        *ngIf=\"!isMultiSelect\"\n        (click)=\"onSelectOption(option)\"\n        class=\"doka-select-dropdown-entry md:doka-min-h-14\"\n      >\n        <ng-container [ngTemplateOutlet]=\"option.template\"></ng-container>\n      </li>\n      }\n      <li *ngIf=\"showCloseRow\" class=\"doka-select-dropdown-entry close-row\">\n        <div class=\"doka-flex-row doka-flex width-100 justify-content-center\">\n          <span class=\"material-icons-outlined doka-icon icon-base\">\n            keyboard_arrow_up\n          </span>\n        </div>\n      </li>\n    </ul>\n  </div>\n</label>\n", styles: [".close-row{border-top:1px solid black;position:sticky;bottom:0;background:#fff;padding:var(--spacing-base);min-height:0px!important}.doka-select-container{pointer-events:none}.doka-select-container *{pointer-events:auto}.close-row:hover{background:#fff}.doka-search-field-container{position:sticky;top:0;z-index:1;padding:var(--spacing-base);background:#fff}.doka-select-dropdown{max-height:250px;padding:0;z-index:11}.doka-select-dropdown-entry{justify-content:center;display:flex;flex-flow:column}.hidden{display:none}.shaded:not(:hover){background:var(--color-background-gray-ultra-ultra-light)}.smaller-line{line-height:1rem}.doka-select-container{min-width:209px}.doka-select-chip-container{padding-right:36px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-select', template: "<label class=\"doka-select-container\">\n  <span class=\"doka-select-label\" *ngIf=\"label || labelT\">\n    @if(label && !labelT) {\n    {{ label }}\n    }\n    <ng-container [ngTemplateOutlet]=\"labelT\"></ng-container>\n  </span>\n  <span class=\"doka-select-description\" *ngIf=\"desc || descT\">\n    <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n    <ng-container [ngTemplateOutlet]=\"descT\"></ng-container>\n  </span>\n  <div class=\"doka-select-wrapper\" #wrapper>\n    <div\n      class=\"doka-select\"\n      [ngClass]=\"{\n        'doka-select-required': required,\n        'doka-select-disabled': disabled,\n        'doka-select-readonly': readonly\n      }\"\n    >\n      <div class=\"doka-select-chip-container\" *ngIf=\"isMultiSelect\">\n        <!--  -->\n        <p *ngIf=\"isValueEmpty()\" class=\"doka-text-text-disabled\">\n          {{ placeholder }}\n        </p>\n        @for(val of getValueArray(); track val) {\n        <div class=\"doka-chip\">\n          <span>\n            {{ getValueLabel(val) }}\n          </span>\n          <button class=\"doka-chip-action\">\n            <span\n              (click)=\"\n                removeSelection($event, val);\n                $event.preventDefault();\n                $event.stopPropagation()\n              \"\n              class=\"doka-chip-action-remove\"\n            ></span>\n          </button>\n        </div>\n        }\n      </div>\n      <input\n        [ngClass]=\"{ 'doka-hidden': isMultiSelect }\"\n        class=\"doka-select-input\"\n        [value]=\"!isValueArray() && value ? getValueLabel(value) : ''\"\n        [placeholder]=\"placeholder\"\n        [readOnly]=\"true\"\n      />\n    </div>\n    <ul\n      class=\"doka-select-dropdown\"\n      #dropdown\n      *ngIf=\"showEntries && !showAsModal\"\n    >\n      <div class=\"doka-search-field-container\" *ngIf=\"showSearchBar\">\n        <div class=\"doka-search-field-input\">\n          <input\n            #searchBar\n            type=\"text\"\n            class=\"doka-search-field\"\n            [placeholder]=\"placeholderSearchBar\"\n            (input)=\"onSearchChanged($event)\"\n          />\n          <button\n            class=\"doka-search-field-clearButton\"\n            (click)=\"search(''); $event.stopPropagation()\"\n            tabindex=\"-1\"\n          ></button>\n        </div>\n      </div>\n      @for(option of searchText ? getSearchOptions() : selectOptions; track\n      option) {\n      <li\n        *ngIf=\"isMultiSelect\"\n        class=\"doka-select-dropdown-entry md:doka-min-h-14\"\n      >\n        <ng-container [ngTemplateOutlet]=\"option.template\"></ng-container>\n      </li>\n      <li\n        *ngIf=\"!isMultiSelect\"\n        (click)=\"onSelectOption(option)\"\n        class=\"doka-select-dropdown-entry md:doka-min-h-14\"\n      >\n        <ng-container [ngTemplateOutlet]=\"option.template\"></ng-container>\n      </li>\n      }\n      <li *ngIf=\"showCloseRow\" class=\"doka-select-dropdown-entry close-row\">\n        <div class=\"doka-flex-row doka-flex width-100 justify-content-center\">\n          <span class=\"material-icons-outlined doka-icon icon-base\">\n            keyboard_arrow_up\n          </span>\n        </div>\n      </li>\n    </ul>\n  </div>\n</label>\n", styles: [".close-row{border-top:1px solid black;position:sticky;bottom:0;background:#fff;padding:var(--spacing-base);min-height:0px!important}.doka-select-container{pointer-events:none}.doka-select-container *{pointer-events:auto}.close-row:hover{background:#fff}.doka-search-field-container{position:sticky;top:0;z-index:1;padding:var(--spacing-base);background:#fff}.doka-select-dropdown{max-height:250px;padding:0;z-index:11}.doka-select-dropdown-entry{justify-content:center;display:flex;flex-flow:column}.hidden{display:none}.shaded:not(:hover){background:var(--color-background-gray-ultra-ultra-light)}.smaller-line{line-height:1rem}.doka-select-container{min-width:209px}.doka-select-chip-container{padding-right:36px}\n"] }]
        }], ctorParameters: () => [{ type: DokaCommonService }, { type: i0.ElementRef }, { type: DokaSelectService }, { type: i0.NgZone }], propDecorators: { desc: [{
                type: Input
            }], disabled: [{
                type: Input
            }], isMultiSelect: [{
                type: Input
            }], cancelButtonText: [{
                type: Input
            }], confirmButtonText: [{
                type: Input
            }], label: [{
                type: Input
            }], readonly: [{
                type: Input
            }], required: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], placeholderSearchBar: [{
                type: Input
            }], showAsModal: [{
                type: Input
            }], showCloseRow: [{
                type: Input
            }], showSearchBar: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], labelT: [{
                type: ContentChild,
                args: ['label', { static: false }]
            }], descT: [{
                type: ContentChild,
                args: ['desc', { static: false }]
            }], selectOptions: [{
                type: ContentChildren,
                args: [SelectOptionComponent, { descendants: true }]
            }], dropdown: [{
                type: ViewChild,
                args: ['dropdown', { static: false }]
            }], wrapper: [{
                type: ViewChild,
                args: ['wrapper', { static: false }]
            }] } });

class SlideOverComponent {
    constructor() {
        this.title = null;
        this.desc = null;
        this.onCloseClicked = new EventEmitter();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SlideOverComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: SlideOverComponent, selector: "doka-slide-over", inputs: { title: "title", desc: "desc" }, outputs: { onCloseClicked: "onCloseClicked" }, host: { classAttribute: "doka-slide-over" }, queries: [{ propertyName: "titleT", first: true, predicate: ["title"], descendants: true }, { propertyName: "descT", first: true, predicate: ["desc"], descendants: true }, { propertyName: "bodyT", first: true, predicate: ["body"], descendants: true }, { propertyName: "buttonsT", first: true, predicate: ["buttons"], descendants: true }], ngImport: i0, template: "<div class=\"doka-slide-over-header\">\n  <div class=\"doka-slide-over-header-content\">\n    <span class=\"doka-slide-over-title\" *ngIf=\"title || titleT\">\n      <ng-container *ngTemplateOutlet=\"titleT\"></ng-container>\n      <p *ngIf=\"title && !titleT\">{{ title }}</p>\n    </span>\n    <span class=\"doka-slide-over-description\" *ngIf=\"desc || descT\">\n      <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n      <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n    </span>\n  </div>\n  <button\n    class=\"doka-slide-over-close\"\n    (click)=\"onCloseClicked.emit($event)\"\n  ></button>\n</div>\n<div class=\"doka-slide-over-body\" *ngIf=\"bodyT\">\n  <ng-container *ngTemplateOutlet=\"bodyT\"></ng-container>\n</div>\n<div class=\"doka-slide-over-footer\" *ngIf=\"buttonsT\">\n  <ng-container *ngTemplateOutlet=\"buttonsT\"></ng-container>\n</div>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SlideOverComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-slide-over', host: { class: 'doka-slide-over' }, template: "<div class=\"doka-slide-over-header\">\n  <div class=\"doka-slide-over-header-content\">\n    <span class=\"doka-slide-over-title\" *ngIf=\"title || titleT\">\n      <ng-container *ngTemplateOutlet=\"titleT\"></ng-container>\n      <p *ngIf=\"title && !titleT\">{{ title }}</p>\n    </span>\n    <span class=\"doka-slide-over-description\" *ngIf=\"desc || descT\">\n      <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n      <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n    </span>\n  </div>\n  <button\n    class=\"doka-slide-over-close\"\n    (click)=\"onCloseClicked.emit($event)\"\n  ></button>\n</div>\n<div class=\"doka-slide-over-body\" *ngIf=\"bodyT\">\n  <ng-container *ngTemplateOutlet=\"bodyT\"></ng-container>\n</div>\n<div class=\"doka-slide-over-footer\" *ngIf=\"buttonsT\">\n  <ng-container *ngTemplateOutlet=\"buttonsT\"></ng-container>\n</div>\n" }]
        }], ctorParameters: () => [], propDecorators: { titleT: [{
                type: ContentChild,
                args: ['title', { static: false }]
            }], descT: [{
                type: ContentChild,
                args: ['desc', { static: false }]
            }], bodyT: [{
                type: ContentChild,
                args: ['body', { static: false }]
            }], buttonsT: [{
                type: ContentChild,
                args: ['buttons', { static: false }]
            }], title: [{
                type: Input
            }], desc: [{
                type: Input
            }], onCloseClicked: [{
                type: Output
            }] } });

class SliderComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SliderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: SliderComponent, selector: "lib-slider", ngImport: i0, template: "<p>slider works!</p>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-slider', template: "<p>slider works!</p>\n" }]
        }] });

const SpinnerSize = {
    ExtraSmall: 16,
    Small: 32,
    Medium: 64,
    Large: 128,
    ExtraLarge: 180
};

class SpinnerComponent {
    constructor(_dokaSpinner) {
        this._dokaSpinner = _dokaSpinner;
        this.size = SpinnerSize.Small;
        this.color = 'var(--color-background-accent)';
    }
    ngAfterViewInit() {
        if (this.size) {
            this._dokaSpinner.nativeElement.style.height = `${this.size}px`;
            this._dokaSpinner.nativeElement.style.width = `${this.size}px`;
            this._dokaSpinner.nativeElement.style['border-radius'] = `${this.size}px`;
            this._dokaSpinner.nativeElement.style['border-width'] = `${this.size / 10}px`;
        }
        this._dokaSpinner.nativeElement.style['border-color'] = `${this.color}`;
        this._dokaSpinner.nativeElement.style['border-right-color'] = 'transparent';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SpinnerComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: SpinnerComponent, selector: "doka-spinner", inputs: { size: "size", color: "color" }, host: { classAttribute: "doka-spinner" }, ngImport: i0, template: "\n", styles: [":host{margin:0}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: SpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-spinner', host: { class: 'doka-spinner' }, template: "\n", styles: [":host{margin:0}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { size: [{
                type: Input
            }], color: [{
                type: Input,
                args: ['color']
            }] } });

const StatusIndicatorType = {
    Active: 'active',
    Neutral: 'neutral',
    Alert: 'alert',
    Warning: 'warning',
    Success: 'success',
};

class StatusIndicatorComponent {
    constructor() {
        this.type = StatusIndicatorType.Active;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: StatusIndicatorComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: StatusIndicatorComponent, selector: "doka-status-indicator", inputs: { type: "type" }, queries: [{ propertyName: "contentT", first: true, predicate: ["content"], descendants: true }], ngImport: i0, template: "<span\n  class=\"doka-status-indicator\"\n  [ngClass]=\"{\n    'doka-status-indicator-success': type === 'success',\n    'doka-status-indicator-warning': type === 'warning',\n    'doka-status-indicator-neutral': type === 'neutral',\n    'doka-status-indicator-alert': type === 'alert'\n  }\"\n>\n  <ng-container *ngTemplateOutlet=\"contentT\"></ng-container>\n  <ng-content *ngIf=\"!contentT\"></ng-content>\n</span>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: StatusIndicatorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-status-indicator', template: "<span\n  class=\"doka-status-indicator\"\n  [ngClass]=\"{\n    'doka-status-indicator-success': type === 'success',\n    'doka-status-indicator-warning': type === 'warning',\n    'doka-status-indicator-neutral': type === 'neutral',\n    'doka-status-indicator-alert': type === 'alert'\n  }\"\n>\n  <ng-container *ngTemplateOutlet=\"contentT\"></ng-container>\n  <ng-content *ngIf=\"!contentT\"></ng-content>\n</span>\n" }]
        }], propDecorators: { type: [{
                type: Input
            }], contentT: [{
                type: ContentChild,
                args: ['content']
            }] } });

class TextAreaComponent {
    constructor() {
        this.alert = null;
        this.disabled = false;
        this.rows = 4;
        this.label = null;
        this.maxLength = null;
        this.readonly = false;
        this.required = false;
        this.placeholder = '';
        this.value = '';
        this.valueChange = new EventEmitter();
    }
    onInput(event) {
        this.value = event.target.value;
        this.valueChange.emit(this.value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: TextAreaComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: TextAreaComponent, selector: "doka-text-area", inputs: { alert: "alert", disabled: "disabled", rows: "rows", label: "label", maxLength: "maxLength", readonly: "readonly", required: "required", placeholder: "placeholder", value: "value" }, outputs: { valueChange: "valueChange" }, queries: [{ propertyName: "alertT", first: true, predicate: ["alert"], descendants: true }, { propertyName: "labelT", first: true, predicate: ["label"], descendants: true }], ngImport: i0, template: "<label class=\"doka-text-area-container\">\n  <span class=\"doka-text-area-label\" *ngIf=\"label || labelT\">\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n  </span>\n  <textarea\n    class=\"doka-text-area\"\n    [ngClass]=\"{ 'doka-text-area-required': required }\"\n    [value]=\"value\"\n    [disabled]=\"disabled\"\n    [readOnly]=\"readonly\"\n    (input)=\"onInput($event)\"\n    [placeholder]=\"placeholder\"\n    [rows]=\"rows\"\n  ></textarea>\n  <div class=\"doka-text-area-details\">\n    <span *ngIf=\"alert || alertT\" class=\"doka-text-area-alert-message\">\n      <ng-container *ngTemplateOutlet=\"alertT\"></ng-container>\n      <p *ngIf=\"alert && !alertT\">{{ alert }}</p>\n    </span>\n    <span class=\"doka-text-area-counter\" *ngIf=\"maxLength\">\n      {{ value.length }}/{{ maxLength }}\n    </span>\n  </div>\n</label>\n", styles: [""], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: TextAreaComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-text-area', template: "<label class=\"doka-text-area-container\">\n  <span class=\"doka-text-area-label\" *ngIf=\"label || labelT\">\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n  </span>\n  <textarea\n    class=\"doka-text-area\"\n    [ngClass]=\"{ 'doka-text-area-required': required }\"\n    [value]=\"value\"\n    [disabled]=\"disabled\"\n    [readOnly]=\"readonly\"\n    (input)=\"onInput($event)\"\n    [placeholder]=\"placeholder\"\n    [rows]=\"rows\"\n  ></textarea>\n  <div class=\"doka-text-area-details\">\n    <span *ngIf=\"alert || alertT\" class=\"doka-text-area-alert-message\">\n      <ng-container *ngTemplateOutlet=\"alertT\"></ng-container>\n      <p *ngIf=\"alert && !alertT\">{{ alert }}</p>\n    </span>\n    <span class=\"doka-text-area-counter\" *ngIf=\"maxLength\">\n      {{ value.length }}/{{ maxLength }}\n    </span>\n  </div>\n</label>\n" }]
        }], propDecorators: { alertT: [{
                type: ContentChild,
                args: ['alert', { static: false }]
            }], labelT: [{
                type: ContentChild,
                args: ['label', { static: false }]
            }], alert: [{
                type: Input
            }], disabled: [{
                type: Input
            }], rows: [{
                type: Input
            }], label: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], readonly: [{
                type: Input
            }], required: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }] } });

class TextFieldComponent {
    constructor() {
        this.alert = null;
        this.desc = null;
        this.endDecoIcon = null;
        this.endDecoText = null;
        this.frontDecoText = null;
        this.frontDecoIcon = null;
        this.frontDecoDropdown = null;
        this.endDecoDropdown = null;
        this.disabled = false;
        this.label = '';
        this.placeholder = '';
        this.readonly = false;
        this.required = false;
        this.value = '';
        this.valueChange = new EventEmitter();
    }
    onInput(event) {
        this.value = event.target.value;
        this.valueChange.emit(this.value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: TextFieldComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: TextFieldComponent, selector: "doka-text-field", inputs: { alert: "alert", desc: "desc", endDecoIcon: "endDecoIcon", endDecoText: "endDecoText", frontDecoText: "frontDecoText", frontDecoIcon: "frontDecoIcon", frontDecoDropdown: "frontDecoDropdown", endDecoDropdown: "endDecoDropdown", disabled: "disabled", label: "label", placeholder: "placeholder", readonly: "readonly", required: "required", value: "value" }, outputs: { valueChange: "valueChange" }, queries: [{ propertyName: "alertT", first: true, predicate: ["alert"], descendants: true }, { propertyName: "descT", first: true, predicate: ["desc"], descendants: true }, { propertyName: "labelT", first: true, predicate: ["label"], descendants: true }], ngImport: i0, template: "<label class=\"doka-text-field-container\">\n  <span class=\"doka-text-field-label\" *ngIf=\"label || labelT\">\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n  </span>\n  <span *ngIf=\"desc || descT\" class=\"doka-text-field-description\">\n    <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n    <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n  </span>\n  <div class=\"doka-text-field-input\">\n    <span\n      class=\"doka-text-field-decoration doka-text-field-decoration-dropdown !doka-border-r !doka-border-l\"\n      *ngIf=\"frontDecoDropdown\"\n    >\n      <div class=\"doka-text-field-select-wrapper\">\n        <button class=\"doka-text-field-select\">{{ frontDecoDropdown }}</button>\n      </div>\n    </span>\n    <span\n      class=\"doka-text-field-decoration doka-text-field-decoration-text !doka-border-l\"\n      *ngIf=\"frontDecoText && !frontDecoDropdown\"\n    >\n      {{ frontDecoText }}\n    </span>\n    <span\n      class=\"doka-text-field-decoration doka-text-field-decoration-icon !doka-border-l\"\n      *ngIf=\"frontDecoIcon && !frontDecoText && !frontDecoDropdown\"\n    >\n      {{ frontDecoIcon }}\n    </span>\n    <input\n      type=\"text\"\n      class=\"doka-text-field\"\n      [ngClass]=\"{ 'doka-text-field-required': required }\"\n      [value]=\"value\"\n      (input)=\"onInput($event)\"\n      [placeholder]=\"placeholder\"\n      [disabled]=\"disabled\"\n      [readOnly]=\"readonly\"\n    />\n    <div\n      class=\"doka-text-field-decoration doka-text-field-decoration-dropdown !doka-border-r\"\n      *ngIf=\"endDecoDropdown\"\n    >\n      <div class=\"doka-text-field-select-wrapper\">\n        <button class=\"doka-text-field-select\">{{ endDecoDropdown }}</button>\n      </div>\n    </div>\n    <span\n      class=\"doka-text-field-decoration doka-text-field-decoration-text !doka-border-r\"\n      *ngIf=\"endDecoText && !endDecoDropdown\"\n    >\n      {{ endDecoText }}\n    </span>\n    <span\n      class=\"doka-text-field-decoration doka-text-field-decoration-icon !doka-border-r\"\n      *ngIf=\"endDecoIcon && !endDecoText && !endDecoDropdown\"\n    >\n      {{ endDecoIcon }}\n    </span>\n  </div>\n\n  <span class=\"doka-text-field-alert-message\" *ngIf=\"alert || alertT\">\n    <p *ngIf=\"alert && !alertT\">{{ alert }}</p>\n    <ng-container *ngTemplateOutlet=\"alertT\"></ng-container>\n  </span>\n</label>\n", styles: [".doka-text-field-decoration{background:#fff}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: TextFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-text-field', template: "<label class=\"doka-text-field-container\">\n  <span class=\"doka-text-field-label\" *ngIf=\"label || labelT\">\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n  </span>\n  <span *ngIf=\"desc || descT\" class=\"doka-text-field-description\">\n    <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n    <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n  </span>\n  <div class=\"doka-text-field-input\">\n    <span\n      class=\"doka-text-field-decoration doka-text-field-decoration-dropdown !doka-border-r !doka-border-l\"\n      *ngIf=\"frontDecoDropdown\"\n    >\n      <div class=\"doka-text-field-select-wrapper\">\n        <button class=\"doka-text-field-select\">{{ frontDecoDropdown }}</button>\n      </div>\n    </span>\n    <span\n      class=\"doka-text-field-decoration doka-text-field-decoration-text !doka-border-l\"\n      *ngIf=\"frontDecoText && !frontDecoDropdown\"\n    >\n      {{ frontDecoText }}\n    </span>\n    <span\n      class=\"doka-text-field-decoration doka-text-field-decoration-icon !doka-border-l\"\n      *ngIf=\"frontDecoIcon && !frontDecoText && !frontDecoDropdown\"\n    >\n      {{ frontDecoIcon }}\n    </span>\n    <input\n      type=\"text\"\n      class=\"doka-text-field\"\n      [ngClass]=\"{ 'doka-text-field-required': required }\"\n      [value]=\"value\"\n      (input)=\"onInput($event)\"\n      [placeholder]=\"placeholder\"\n      [disabled]=\"disabled\"\n      [readOnly]=\"readonly\"\n    />\n    <div\n      class=\"doka-text-field-decoration doka-text-field-decoration-dropdown !doka-border-r\"\n      *ngIf=\"endDecoDropdown\"\n    >\n      <div class=\"doka-text-field-select-wrapper\">\n        <button class=\"doka-text-field-select\">{{ endDecoDropdown }}</button>\n      </div>\n    </div>\n    <span\n      class=\"doka-text-field-decoration doka-text-field-decoration-text !doka-border-r\"\n      *ngIf=\"endDecoText && !endDecoDropdown\"\n    >\n      {{ endDecoText }}\n    </span>\n    <span\n      class=\"doka-text-field-decoration doka-text-field-decoration-icon !doka-border-r\"\n      *ngIf=\"endDecoIcon && !endDecoText && !endDecoDropdown\"\n    >\n      {{ endDecoIcon }}\n    </span>\n  </div>\n\n  <span class=\"doka-text-field-alert-message\" *ngIf=\"alert || alertT\">\n    <p *ngIf=\"alert && !alertT\">{{ alert }}</p>\n    <ng-container *ngTemplateOutlet=\"alertT\"></ng-container>\n  </span>\n</label>\n", styles: [".doka-text-field-decoration{background:#fff}\n"] }]
        }], propDecorators: { alertT: [{
                type: ContentChild,
                args: ['alert', { static: false }]
            }], descT: [{
                type: ContentChild,
                args: ['desc', { static: false }]
            }], labelT: [{
                type: ContentChild,
                args: ['label', { static: false }]
            }], alert: [{
                type: Input
            }], desc: [{
                type: Input
            }], endDecoIcon: [{
                type: Input
            }], endDecoText: [{
                type: Input
            }], frontDecoText: [{
                type: Input
            }], frontDecoIcon: [{
                type: Input
            }], frontDecoDropdown: [{
                type: Input
            }], endDecoDropdown: [{
                type: Input
            }], disabled: [{
                type: Input
            }], label: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], readonly: [{
                type: Input
            }], required: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }] } });

class TimeFieldComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: TimeFieldComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: TimeFieldComponent, selector: "lib-time-field", ngImport: i0, template: "<p>time-field works!</p>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: TimeFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-time-field', template: "<p>time-field works!</p>\n" }]
        }] });

class ToggleSwitchComponent {
    constructor() {
        this.alert = null;
        this.desc = null;
        this.disabled = null;
        this.label = '';
        this.checked = false;
        this.rightAlign = false;
        this.checkedChange = new EventEmitter();
    }
    onCheckedChange(event) {
        this.checked = event.target.checked;
        this.checkedChange.emit(this.checked);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ToggleSwitchComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: ToggleSwitchComponent, selector: "doka-toggle", inputs: { alert: "alert", desc: "desc", disabled: "disabled", label: "label", checked: "checked", rightAlign: "rightAlign" }, outputs: { checkedChange: "checkedChange" }, queries: [{ propertyName: "alertT", first: true, predicate: ["alert"], descendants: true }, { propertyName: "descT", first: true, predicate: ["desc"], descendants: true }, { propertyName: "labelT", first: true, predicate: ["label"], descendants: true }], ngImport: i0, template: "<label class=\"doka-toggle-container\">\n  <ng-container\n    *ngTemplateOutlet=\"rightAlign ? inputLabel : input\"\n  ></ng-container>\n  <ng-container\n    *ngTemplateOutlet=\"rightAlign ? input : inputLabel\"\n  ></ng-container>\n</label>\n\n<ng-template #input>\n  <input\n    class=\"doka-toggle\"\n    [ngClass]=\"{ 'doka-toggle-right': rightAlign }\"\n    [disabled]=\"disabled\"\n    [checked]=\"checked\"\n    (change)=\"onCheckedChange($event)\"\n    type=\"checkbox\"\n  />\n</ng-template>\n<ng-template #inputLabel>\n  <span class=\"doka-toggle-label\" *ngIf=\"label || labelT\">\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n  </span>\n  <span class=\"doka-toggle-description\" *ngIf=\"desc || descT\">\n    <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n    <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n  </span>\n  <span class=\"doka-toggle-alert-message\" *ngIf=\"alert || alertT\">\n    <p *ngIf=\"alert && !alertT\">{{ alert }}</p>\n    <ng-container *ngTemplateOutlet=\"alertT\"></ng-container>\n  </span>\n</ng-template>\n", styles: [":host{height:fit-content}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ToggleSwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'doka-toggle', template: "<label class=\"doka-toggle-container\">\n  <ng-container\n    *ngTemplateOutlet=\"rightAlign ? inputLabel : input\"\n  ></ng-container>\n  <ng-container\n    *ngTemplateOutlet=\"rightAlign ? input : inputLabel\"\n  ></ng-container>\n</label>\n\n<ng-template #input>\n  <input\n    class=\"doka-toggle\"\n    [ngClass]=\"{ 'doka-toggle-right': rightAlign }\"\n    [disabled]=\"disabled\"\n    [checked]=\"checked\"\n    (change)=\"onCheckedChange($event)\"\n    type=\"checkbox\"\n  />\n</ng-template>\n<ng-template #inputLabel>\n  <span class=\"doka-toggle-label\" *ngIf=\"label || labelT\">\n    <p *ngIf=\"label && !labelT\">{{ label }}</p>\n    <ng-container *ngTemplateOutlet=\"labelT\"></ng-container>\n  </span>\n  <span class=\"doka-toggle-description\" *ngIf=\"desc || descT\">\n    <p *ngIf=\"desc && !descT\">{{ desc }}</p>\n    <ng-container *ngTemplateOutlet=\"descT\"></ng-container>\n  </span>\n  <span class=\"doka-toggle-alert-message\" *ngIf=\"alert || alertT\">\n    <p *ngIf=\"alert && !alertT\">{{ alert }}</p>\n    <ng-container *ngTemplateOutlet=\"alertT\"></ng-container>\n  </span>\n</ng-template>\n", styles: [":host{height:fit-content}\n"] }]
        }], propDecorators: { alertT: [{
                type: ContentChild,
                args: ['alert', { static: false }]
            }], descT: [{
                type: ContentChild,
                args: ['desc', { static: false }]
            }], labelT: [{
                type: ContentChild,
                args: ['label', { static: false }]
            }], alert: [{
                type: Input
            }], desc: [{
                type: Input
            }], disabled: [{
                type: Input
            }], label: [{
                type: Input
            }], checked: [{
                type: Input
            }], rightAlign: [{
                type: Input
            }], checkedChange: [{
                type: Output
            }] } });

class ToolTipComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ToolTipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.2.11", type: ToolTipComponent, selector: "lib-tool-tip", ngImport: i0, template: "<p>tool-tip works!</p>\n", styles: [""] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: ToolTipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-tool-tip', template: "<p>tool-tip works!</p>\n" }]
        }] });

const MeasurementSystem = {
    Metric: "metric",
    Imperial: "imperial"
};

class WeightPipe {
    transform(value, convertTo) {
        if (convertTo === MeasurementSystem.Metric) {
            const weightString = (Math.round((value + Number.EPSILON) * 100) / 100).toLocaleString() + " kg";
            return weightString;
        }
        else if (convertTo === MeasurementSystem.Imperial) {
            const weightString = (Math.round(((value / 0.45359237) + Number.EPSILON) * 100) / 100).toLocaleString() + " lbs";
            return weightString;
        }
        else {
            const weightString = (Math.round((value + Number.EPSILON) * 100) / 100).toLocaleString() + " kg";
            return weightString;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: WeightPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "18.2.11", ngImport: i0, type: WeightPipe, name: "weight" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: WeightPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'weight'
                }]
        }] });

class DokaCommonModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaCommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.11", ngImport: i0, type: DokaCommonModule, declarations: [AccordionComponent,
            AccordionItemComponent,
            ActionIconComponent,
            AvatarComponent,
            BadgeComponent,
            BannerComponent,
            ButtonComponent,
            CommonComponent,
            CardComponent,
            CheckboxComponent,
            ChipComponent,
            DateInputComponent,
            DatePickerComponent,
            EmptyStateComponent,
            ErrorToastDetailsComponent,
            ImagePickerComponent,
            InlineNotificationComponent,
            LinkComponent,
            ModalComponent,
            NotificationIndicatorComponent,
            NumberInputComponent,
            ProgressBarComponent,
            RadioButtonComponent,
            RadioButtonGroupComponent,
            SelectComponent,
            SelectOptionComponent,
            SelectModalComponent,
            SpinnerComponent,
            ToastComponent,
            WeightPipe,
            InlineNotificationComponent,
            SearchFieldComponent,
            SlideOverComponent,
            SliderComponent,
            StatusIndicatorComponent,
            TextAreaComponent,
            TextFieldComponent,
            TimeFieldComponent,
            ToggleSwitchComponent,
            ToolTipComponent,
            IconComponent,
            LandscapeOnlyDirective,
            PortraitOnlyDirective], imports: [CommonModule, IonicModule, I18NextModule, i1$1.IonicModule], exports: [AccordionComponent,
            AccordionItemComponent,
            ActionIconComponent,
            AvatarComponent,
            BannerComponent,
            BadgeComponent,
            ButtonComponent,
            CardComponent,
            CheckboxComponent,
            ChipComponent,
            CommonComponent,
            DateInputComponent,
            EmptyStateComponent,
            ErrorToastDetailsComponent,
            IconComponent,
            ImagePickerComponent,
            InlineNotificationComponent,
            LinkComponent,
            ModalComponent,
            NotificationIndicatorComponent,
            NumberInputComponent,
            ProgressBarComponent,
            RadioButtonComponent,
            RadioButtonGroupComponent,
            SearchFieldComponent,
            SelectComponent,
            SelectOptionComponent,
            SlideOverComponent,
            SpinnerComponent,
            StatusIndicatorComponent,
            TextAreaComponent,
            TextFieldComponent,
            ToastComponent,
            ToggleSwitchComponent,
            WeightPipe,
            LandscapeOnlyDirective,
            PortraitOnlyDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaCommonModule, imports: [CommonModule, IonicModule, I18NextModule, IonicModule.forRoot()] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.11", ngImport: i0, type: DokaCommonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AccordionComponent,
                        AccordionItemComponent,
                        ActionIconComponent,
                        AvatarComponent,
                        BadgeComponent,
                        BannerComponent,
                        ButtonComponent,
                        CommonComponent,
                        CardComponent,
                        CheckboxComponent,
                        ChipComponent,
                        DateInputComponent,
                        DatePickerComponent,
                        EmptyStateComponent,
                        ErrorToastDetailsComponent,
                        ImagePickerComponent,
                        InlineNotificationComponent,
                        LinkComponent,
                        ModalComponent,
                        NotificationIndicatorComponent,
                        NumberInputComponent,
                        ProgressBarComponent,
                        RadioButtonComponent,
                        RadioButtonGroupComponent,
                        SelectComponent,
                        SelectOptionComponent,
                        SelectModalComponent,
                        SpinnerComponent,
                        ToastComponent,
                        WeightPipe,
                        InlineNotificationComponent,
                        SearchFieldComponent,
                        SlideOverComponent,
                        SliderComponent,
                        StatusIndicatorComponent,
                        TextAreaComponent,
                        TextFieldComponent,
                        TimeFieldComponent,
                        ToggleSwitchComponent,
                        ToolTipComponent,
                        IconComponent,
                        LandscapeOnlyDirective,
                        PortraitOnlyDirective
                    ],
                    imports: [CommonModule, IonicModule, I18NextModule, IonicModule.forRoot()],
                    exports: [
                        AccordionComponent,
                        AccordionItemComponent,
                        ActionIconComponent,
                        AvatarComponent,
                        BannerComponent,
                        BadgeComponent,
                        ButtonComponent,
                        CardComponent,
                        CheckboxComponent,
                        ChipComponent,
                        CommonComponent,
                        DateInputComponent,
                        EmptyStateComponent,
                        ErrorToastDetailsComponent,
                        IconComponent,
                        ImagePickerComponent,
                        InlineNotificationComponent,
                        LinkComponent,
                        ModalComponent,
                        NotificationIndicatorComponent,
                        NumberInputComponent,
                        ProgressBarComponent,
                        RadioButtonComponent,
                        RadioButtonGroupComponent,
                        SearchFieldComponent,
                        SelectComponent,
                        SelectOptionComponent,
                        SlideOverComponent,
                        SpinnerComponent,
                        StatusIndicatorComponent,
                        TextAreaComponent,
                        TextFieldComponent,
                        ToastComponent,
                        ToggleSwitchComponent,
                        WeightPipe,
                        LandscapeOnlyDirective,
                        PortraitOnlyDirective
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

const ButtonColor = {
    Primary: "primary",
    Secondary: "secondary",
    Danger: "danger",
    Clear: "clear",
};

class ModalChildComponent {
    constructor(dynamicService, modalCtrl) {
        this.dynamicService = dynamicService;
        this.modalCtrl = modalCtrl;
        this.destroyRef = inject(DestroyRef);
        this.dynamicService
            .getSubmission()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((data) => {
            if (data) {
                void this.onSubmit();
            }
            else {
                void this.closeModal();
            }
        });
    }
    /**
     * This method is called when the user clicks the submit button. Usually, this method should be overridden by the child component.
     */
    async onSubmit() {
        await this.modalCtrl.dismiss(ModalDismissAction.CONFIRM);
    }
    /**
     * This method closes the modal. It can be called with data and an action.
     * @param data
     * @param action
     */
    async closeModal(data, action = ModalDismissAction.CANCEL) {
        await this.modalCtrl.dismiss(data, action);
    }
}

const ModalButtonRole = {
    Action: "action",
    Cancel: "cancel"
};

class SelectModalInputs {
    constructor() {
        this.checked = false;
        //test
    }
}

/*
 * Public API Surface of common
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccordionComponent, AccordionItemComponent, ActionIconComponent, ActionIconSize, ActionIconType, AvatarComponent, AvatarSize, BadgeComponent, BadgeIconPosition, BadgeSize, BadgeType, BannerComponent, BannerType, ButtonColor, ButtonComponent, CardComponent, CheckboxComponent, ChipComponent, ChipType, CommonComponent, DateInputComponent, DokaCommonModule, DokaCommonService, DokaSelectService, DokaToastService, EmptyStateComponent, ErrorToastDetailsComponent, IconComponent, IconSize, IconType, ImagePickerComponent, InlineNotificationComponent, InlineNotificationType, LandscapeOnlyDirective, LinkComponent, MeasurementSystem, ModalActionHandlingService, ModalButtonRole, ModalChildComponent, ModalComponent, ModalDismissAction, ModalStyle, NotificationIndicatorComponent, NotificationIndicatorType, NumberInputComponent, PlatformService, PlatformType, PortraitOnlyDirective, ProgressBarComponent, ProgressBarType, RadioButtonComponent, RadioButtonGroupComponent, ScreenOrientation, ScreenService, SearchFieldComponent, SelectComponent, SelectModalInputs, SelectOptionComponent, SlideOverComponent, SpinnerComponent, SpinnerSize, StatusIndicatorComponent, StatusIndicatorType, TextAreaComponent, TextFieldComponent, ToastComponent, ToastErrorTranslations, ToastPosition, ToastType, ToggleSwitchComponent, UIStyle, WeightPipe };
